const getProductMediaSlideKey = (slide) => {
  if (!slide) return null;
  return slide.dataset.mediaId || slide.dataset.mediaModalId || null;
};

const findProductMediaSlideIndex = (swiperContainer, mediaId, sectionId) => {
  if (!swiperContainer?.swiper || !mediaId) return -1;
  const fullKey = sectionId ? `${sectionId}-${mediaId}` : mediaId;
  return swiperContainer.swiper.slides.findIndex((slide) => {
    const slideKey = getProductMediaSlideKey(slide);
    if (slideKey && (slideKey === fullKey || slideKey === mediaId)) {
      return true;
    }
    return slide.querySelector(`[data-media-id="${mediaId}"]`) != null;
  });
};

const syncPopupSliderToMain = () => {
  const mainSlider = document.querySelector(".js-media-list");
  const popupSlider = document.querySelector(".js-popup-slider");
  if (!mainSlider?.swiper || !popupSlider?.swiper) return;

  const mediaKey = getProductMediaSlideKey(
    mainSlider.swiper.slides[mainSlider.swiper.activeIndex]
  );
  if (!mediaKey) return;

  const popupIndex = popupSlider.swiper.slides.findIndex(
    (slide) => getProductMediaSlideKey(slide) === mediaKey
  );
  if (popupIndex >= 0 && popupSlider.swiper.activeIndex !== popupIndex) {
    popupSlider.swiper.slideTo(popupIndex);
  }
};

const syncMainSliderToPopup = () => {
  const mainSlider = document.querySelector(".js-media-list");
  const popupSlider = document.querySelector(".js-popup-slider");
  if (!mainSlider?.swiper || !popupSlider?.swiper) return;

  const mediaKey = getProductMediaSlideKey(
    popupSlider.swiper.slides[popupSlider.swiper.activeIndex]
  );
  if (!mediaKey) return;

  const mainIndex = mainSlider.swiper.slides.findIndex(
    (slide) => getProductMediaSlideKey(slide) === mediaKey
  );
  if (mainIndex >= 0 && mainSlider.swiper.activeIndex !== mainIndex) {
    mainSlider.swiper.slideTo(mainIndex);
  }
};

const syncPopupSliderToOpener = (opener, modalEl) => {
  const popupSlider =
    modalEl?.querySelector(".js-popup-slider") ||
    document.querySelector(".js-popup-slider");
  if (!popupSlider?.swiper || !opener) return;

  const mediaId = opener.getAttribute("data-media-id");
  if (!mediaId) {
    syncPopupSliderToMain();
    return;
  }

  const sectionId =
    modalEl?.id?.replace("ProductModal-", "") ||
    document.querySelector(".js-media-list")?.dataset?.section;

  const popupIndex = findProductMediaSlideIndex(
    popupSlider,
    mediaId,
    sectionId
  );
  if (popupIndex >= 0) {
    popupSlider.swiper.slideTo(popupIndex, 0);
  }
};

window.syncProductMediaPopup = syncPopupSliderToOpener;

const sliderInit = (section) => {
  if (!section) return;
  if (
    section.querySelectorAll(".js-media-list") &&
    section.querySelectorAll(".js-media-list").length > 0
  ) {
    section.querySelectorAll(".js-media-list").forEach((elem, index) => {
      const navPrev = section.querySelector(
        ".product__slider-nav .swiper-button-prev"
      );
      const navNext = section.querySelector(
        ".product__slider-nav .swiper-button-next"
      );
      const pagination = section.querySelector(".product__pagination");
      let slider = new Swiper(elem, {
        slidesPerView: 1,
        spaceBetween: 8,
        autoHeight: false,
        speed: 500,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: navNext,
          prevEl: navPrev,
        },
        pagination: {
          el: pagination,
          type: "bullets",
          clickable: true,
        },
        thumbs: {
          swiper:
            section.querySelectorAll(".js-media-sublist").length > 0
              ? section.querySelectorAll(".js-media-sublist")[index]?.swiper
              : "",
        },
        on: {
          init: function () {
            syncPopupSliderToMain();
          },
          slideChangeTransitionStart: function () {
            if (section.querySelector(".js-media-sublist")) {
              section
                .querySelector(".js-media-sublist")
                .swiper.slideTo(
                  section.querySelector(".js-media-list").swiper.activeIndex
                );
            }
          },
          slideChange: function () {
            window.pauseAllMedia();
            this.params.noSwiping = false;

            if (
              section.querySelector(".js-popup-slider") &&
              section.querySelector(".js-popup-slider").swiper
            ) {
              section
                .querySelector(".js-popup-slider")
                .swiper.slideTo(this.activeIndex);
            }

            syncPopupSliderToMain();
          },
          slideChangeTransitionEnd: function () {
            if (this.slides[this.activeIndex]?.querySelector("model-viewer")) {
              this.slides[this.activeIndex]
                .querySelector(".shopify-model-viewer-ui__button--poster")
                .removeAttribute("hidden");
            }
          },
          touchStart: function () {
            if (this.slides[this.activeIndex].querySelector("model-viewer")) {
              if (
                !this.slides[this.activeIndex]
                  .querySelector("model-viewer")
                  .classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });
    });
  }
};

const subSliderInit = (section) => {
  if (!section) return;
  if (
    section.querySelectorAll(".js-media-sublist") &&
    section.querySelectorAll(".js-media-sublist").length > 0
  ) {
    section.querySelectorAll(".js-media-sublist").forEach((elem) => {
      const thumbsNav = elem.closest(".product__media-sublist-outer");
      const thumbsNavPrev = thumbsNav?.querySelector(
        ".product__thumbs-nav .swiper-button-prev"
      );
      const thumbsNavNext = thumbsNav?.querySelector(
        ".product__thumbs-nav .swiper-button-next"
      );
      let subSlider = new Swiper(elem, {
        spaceBetween: 8,
        slidesPerView: "auto",
        direction: "horizontal",
        freeMode: true,
        allowTouchMove: true,
        watchSlidesProgress: true,
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: thumbsNavPrev,
          nextEl: thumbsNavNext,
          disabledClass: "swiper-button-disabled",
        },
        on: {
          /* thumbs <> arrows also drive the main image slider (main syncs the strip back via slideChangeTransitionStart) */
          navigationPrev: function () {
            const mainList = elem
              .closest(".product__media-wrapper")
              ?.querySelector(".js-media-list");
            mainList?.swiper?.slidePrev();
          },
          navigationNext: function () {
            const mainList = elem
              .closest(".product__media-wrapper")
              ?.querySelector(".js-media-list");
            mainList?.swiper?.slideNext();
          },
          touchEnd: function (s, e) {
            let range = 5;
            let diff = (s.touches.diff = s.isHorizontal()
              ? s.touches.currentX - s.touches.startX
              : s.touches.currentY - s.touches.startY);
            if (diff < range || diff > -range) s.allowClick = true;
          },
        },
      });
    });
  }
};

const popupSliderInit = (section) => {
  const sliderWrapper = document.querySelector(".js-popup-slider");

  if (sliderWrapper) {
    const buttonPrev = document.querySelector(
      ".product-media-modal__slider-nav-prev"
    );
    const buttonNext = document.querySelector(
      ".product-media-modal__slider-nav-next"
    );

    let popupSlider = new Swiper(sliderWrapper, {
      slidesPerView: 1,
      speed: 500,
      zoom: {
        maxRatio: 2,
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      pagination: {
        el: ".product-media-modal .product__pagination",
        type: "bullets",
        clickable: true,
      },
      breakpoints: {
        990: {
          speed: 750,
        },
      },
      on: {
        afterInit: function () {
          syncPopupSliderToMain();
          section
            .querySelectorAll(".product__media-list .product__media-item")
            .forEach((elem, index) => {
              elem.addEventListener("click", () => {
                if (sliderWrapper.swiper) {
                  sliderWrapper.swiper.slideTo(index, 0);
                  sliderWrapper.swiper.update();
                }
              });
            });
        },

        slideChange: function () {
          window.pauseAllMedia();
          this.params.noSwiping = false;
          sliderWrapper.classList.remove("zoom");
          syncMainSliderToPopup();
        },
        touchMove: function () {
          sliderWrapper.classList.remove("zoom");
        },
        slideChangeTransitionEnd: function () {
          if (this.slides[this.activeIndex].querySelector("model-viewer")) {
            this.slides[this.activeIndex]
              .querySelector(".shopify-model-viewer-ui__button--poster")
              .removeAttribute("hidden");
          }
        },
        touchStart: function () {
          if (this.slides[this.activeIndex].querySelector("model-viewer")) {
            if (
              !this.slides[this.activeIndex]
                .querySelector("model-viewer")
                .classList.contains("shopify-model-viewer-ui__disabled")
            ) {
              this.params.noSwiping = true;
              this.params.noSwipingClass = "swiper-slide";
            } else {
              this.params.noSwiping = false;
            }
          }
        },
      },
    });
  }
};

if (navigator.userAgent.indexOf("iPhone") > -1) {
  document
    .querySelector("[name=viewport]")
    .setAttribute(
      "content",
      "width=device-width, initial-scale=1, maximum-scale=1"
    );
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus?.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => {
    video.pause();
  });
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus && !elementToFocus.classList.contains("card-focused"))
    elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) => {
      this.setMinimumDisable();

      button.addEventListener("click", this.onButtonClick.bind(this));
    });

    var eventList = ["paste", "input"];

    for (event of eventList) {
      this.input.addEventListener(event, function (e) {
        const numberRegex = /^0*?[1-9]\d*$/;

        if (
          numberRegex.test(e.currentTarget.value) ||
          e.currentTarget.value === ""
        ) {
          e.currentTarget.value;
        } else {
          e.currentTarget.value = 1;
        }

        if (e.currentTarget.value === 1 || e.currentTarget.value === "") {
          this.previousElementSibling.classList.add("disabled");
        } else {
          this.previousElementSibling.classList.remove("disabled");
        }
      });
    }

    this.input.addEventListener("focusout", function (e) {
      if (e.currentTarget.value === "") {
        e.currentTarget.value = 1;
      }
    });
  }

  setMinimumDisable() {
    if (this.input.value == 1) {
      this.querySelector('button[name="minus"]').classList.add("disabled");
    } else {
      this.querySelector('button[name="minus"]').classList.remove("disabled");
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    this.setMinimumDisable();
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    if (!opt) return;
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    this.headerWrapper = document.querySelector(".header-wrapper");
    if (this.headerWrapper) this.headerWrapper.preventHide = false;

    //if (navigator.platform === "iPhone")
    //  document.documentElement.style.setProperty(
    //    "--viewport-height",
    //    `${window.innerHeight}px`
    //  );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) => {
      if (
        this.querySelector(".toggle-scheme-button") === button ||
        this.querySelector(".header__localization-button") === button ||
        this.querySelector(".header__localization-lang-button") === button ||
        button.classList.contains("mobile-facets__footer__button") ||
        button.closest(".mobile-mega-menu__products-card")
      ) {
        return;
      }

      button.addEventListener("click", this.onCloseButtonClick.bind(this));
    });
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    if (this.headerWrapper) this.headerWrapper.preventHide = true;
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-drawer`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(`overflow-hidden-drawer`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      if (this.headerWrapper) this.headerWrapper.preventHide = false;
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    if (!detailsElement) return;
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement?.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.header = document.querySelector(".shopify-section-header");
    this.headerWrapper = document.querySelector(".header-wrapper");
    if (this.headerWrapper) this.headerWrapper.preventHide = false;
  }

  openMenuDrawer(summaryElement) {
    if (this.headerWrapper) this.headerWrapper.preventHide = true;
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-drawer`);

    if (this.header.classList.contains("color-background-overlay")) {
      this.header.classList.remove("color-background-overlay");
      this.header.classList.add("color-background-overlay-hidden");
    }
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(`overflow-hidden-drawer`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      if (this.headerWrapper) this.headerWrapper.preventHide = false;
      if (
        this.header.classList.contains("color-background-overlay-hidden") &&
        !this.header.classList.contains("shopify-section-header-sticky")
      ) {
        this.header.classList.add("color-background-overlay");
        this.header.classList.remove("color-background-overlay-hidden");
      }
    }
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    let isOpen = false;

    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

    document.querySelectorAll("body > quick-add-modal").forEach((el) => {
      if (el.hasAttribute("open")) {
        isOpen = true;
      }
    });

    if (!isOpen) {
      document.body.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
    }

    const images = document.querySelector(".product-media-modal__content");

    if (images) {
      images.classList.remove("zoom");
    }
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
    if (this.getAttribute("data-autoplay") === "true") {
      this.loadContent();
    }
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      //window.pauseAllMedia();

      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (
              this.getAttribute("data-autoplay") === "true" &&
              this.closest(".swiper-slide-active")
            ) {
              if (entry.target.nodeName === "VIDEO") {
                let playPromise = entry.target.play();
                if (playPromise !== undefined) {
                  playPromise
                    .then((_) => {})
                    .catch((error) => {
                      console.error("Error playing video:", error);
                    });
                }
              } else if (
                entry.target.nodeName === "IFRAME" &&
                entry.target.contentWindow
              ) {
                if (entry.target.classList.contains("js-youtube")) {
                  entry.target.contentWindow.postMessage(
                    '{"event":"command","func":"playVideo","args":""}',
                    "*"
                  );
                } else {
                  entry.target.contentWindow.postMessage(
                    '{"method":"play"}',
                    "*"
                  );
                }
              }
            }
          } else {
            if (entry.target.nodeName === "VIDEO") {
              entry.target.pause();
            } else if (
              entry.target.nodeName === "IFRAME" &&
              entry.target.contentWindow
            ) {
              if (entry.target.classList.contains("js-youtube")) {
                entry.target.contentWindow.postMessage(
                  '{"event":"command","func":"pauseVideo","args":""}',
                  "*"
                );
              } else {
                entry.target.contentWindow.postMessage(
                  '{"method":"pause"}',
                  "*"
                );
              }
            }
          }
        });
      });

      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );

      if (
        deferredElement.nodeName === "VIDEO" ||
        deferredElement.nodeName === "IFRAME"
      ) {
        videoObserver.observe(deferredElement);
      }

      if (this.closest(".swiper-slide-active")?.querySelector("model-viewer")) {
        const modelViewer = this.closest(".swiper-slide-active").querySelector(
          "model-viewer"
        );

        if (
          !modelViewer.classList.contains("shopify-model-viewer-ui__disabled")
        ) {
          this.closest(".swiper").swiper.params.noSwiping = true;
          this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide";
        }
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

function shopifyProductUrlsDiffer(urlA, urlB) {
  if (!urlA || !urlB) return false;
  try {
    const a = new URL(urlA, window.location.origin);
    const b = new URL(urlB, window.location.origin);
    return a.pathname !== b.pathname || a.search !== b.search;
  } catch {
    return String(urlA).trim() !== String(urlB).trim();
  }
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
    this.needsProductMediaRefresh = false;
    this.pendingCombinedProductURL = "";
    this.productInfoRequestId = 0;
    this.productInfoLoading = false;
    this.pickerUpdateMode = "none";
    this.productInfoPriceUpdated = false;
    this.variantUserInteracted = false;
  }

  connectedCallback() {
    if (this.querySelector("[data-all-variants-no-high]")) {
      this.getVariantData();
      this.updateOptions();
      if (!this.isHighVariantProduct()) {
        this.updateVariantStatuses();
      }
    }

    this.syncAddToCartState();

    if (this.hasCombinedListingOptions()) {
      this.restoreProductInfoVisibility();
    }
  }

  hasCombinedListingOptions() {
    const currentProductUrl = this.normalizeProductUrl(this.dataset.url);
    if (!currentProductUrl) return false;

    return [
      ...this.querySelectorAll(".product-form__controls [data-product-url]"),
    ].some((input) => {
      const productUrl = this.normalizeProductUrl(input.dataset.productUrl);
      return !!productUrl && productUrl !== currentProductUrl;
    });
  }

  normalizeProductUrl(url) {
    if (!url) return "";

    try {
      const pathname = new URL(url, window.location.origin).pathname;
      const productMatch = pathname.match(/\/products\/([^/?#]+)/);
      if (productMatch?.[1]) {
        return `/products/${productMatch[1]}`;
      }
      return pathname;
    } catch {
      return "";
    }
  }

  getSelectedExternalProductURL(baseProductUrl = "") {
    const currentProductUrl = this.normalizeProductUrl(
      baseProductUrl || this.pendingCombinedProductURL || this.dataset.url
    );
    if (!currentProductUrl) return "";

    for (const wrapper of this.getSortedOptionControls()) {
      const selectedInput = this.getSelectedOptionInput(wrapper);
      const productUrl = this.normalizeProductUrl(
        selectedInput?.dataset?.productUrl
      );
      if (productUrl && productUrl !== currentProductUrl) {
        return selectedInput.dataset.productUrl;
      }
    }

    return "";
  }

  shouldTrustSelectedVariantFromScript() {
    return (
      !this.variantUserInteracted &&
      (this.isHighVariantProduct() || !!this.getSelectedExternalProductURL())
    );
  }

  isHighVariantProduct() {
    return this.dataset.isHighVariantProduct === "true";
  }

  isQuickAddModalContext() {
    return !!this.closest("quick-add-modal");
  }

  needsSectionIdRewrite() {
    return (
      !!this.dataset.originalSection &&
      this.dataset.section !== this.dataset.originalSection
    );
  }

  rewriteFetchedMarkupForSection(markup, sourceSectionId, currentSectionId) {
    if (!markup || sourceSectionId === currentSectionId) return markup;
    return markup.replaceAll(sourceSectionId, currentSectionId);
  }

  syncPickerDatasetFromHtml(html) {
    const sourceSectionId =
      this.dataset.originalSection || this.dataset.section;
    const sourcePicker = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    if (!sourcePicker) return;

    if (sourcePicker.dataset.url) {
      this.dataset.url = sourcePicker.dataset.url;
    }
    if (sourcePicker.dataset.isHighVariantProduct !== undefined) {
      this.dataset.isHighVariantProduct =
        sourcePicker.dataset.isHighVariantProduct;
    }
    if (sourcePicker.dataset.variantMediaDisplay) {
      this.dataset.variantMediaDisplay =
        sourcePicker.dataset.variantMediaDisplay;
    }
  }

  getSelectedOptionValueId(control) {
    const selectedInput = this.getSelectedOptionInput(control);
    if (selectedInput?.dataset?.optionValueId) {
      return selectedInput.dataset.optionValueId;
    }

    const hidden = control.querySelector(
      "variant-dropdown-select input[type='hidden']"
    );
    return hidden?.dataset?.optionValueId || null;
  }

  buildServerVariantRequestUrl(
    combinedProductURL = "",
    { preferOptionValues = false } = {}
  ) {
    const productURL =
      combinedProductURL || this.pendingCombinedProductURL || this.dataset.url;
    const selectedValuesIds = this.getSelectedValuesIds();

    if (preferOptionValues && selectedValuesIds.length) {
      return this.createRequestUrl({
        selectedValuesIds,
        combinedProductURL: productURL,
        preferOptionValues: true,
      });
    }

    if (this.currentVariant?.id) {
      return this.createRequestUrl({
        currentVariantId: this.currentVariant.id,
        combinedProductURL: productURL,
      });
    }

    if (selectedValuesIds.length) {
      return this.createRequestUrl({
        selectedValuesIds,
        combinedProductURL: productURL,
        preferOptionValues: true,
      });
    }

    return this.createRequestUrl({ combinedProductURL: productURL });
  }

  getChangedOptionIndex(event) {
    const controls = [...this.querySelectorAll(".product-form__controls")];
    const changedControl = event.target.closest(".product-form__controls");
    if (!changedControl) return -1;
    return controls.indexOf(changedControl);
  }

  getMediaHtmlRoot(html, sourceSectionId) {
    return (
      html.getElementById?.(`shopify-section-${sourceSectionId}`) ||
      html.getElementById?.(`MainProduct-${sourceSectionId}`) ||
      html
    );
  }

  hasRealProductGalleryInHtml(html, sourceSectionId) {
    const mediaHtmlRoot = this.getMediaHtmlRoot(html, sourceSectionId);
    const mediaSource = mediaHtmlRoot.querySelector(
      `[data-section="product-media-${sourceSectionId}"]`
    );
    return Boolean(mediaSource?.querySelector(".js-media-list"));
  }

  countMediaSlidesInHtml(html, sourceSectionId) {
    const mediaHtmlRoot = this.getMediaHtmlRoot(html, sourceSectionId);
    const mediaSource = mediaHtmlRoot.querySelector(
      `[data-section="product-media-${sourceSectionId}"]`
    );
    if (!mediaSource) return 0;
    if (mediaSource.querySelector(".js-media-list")) {
      return mediaSource.querySelectorAll(
        ".js-media-list .swiper-slide, .product__media-list-inner .product__media-item, .product__media-sublist .swiper-slide"
      ).length;
    }
    return 0;
  }

  getSelectedOptionInput(control) {
    const selectedValue = this.getSelectedOptionValue(control);
    if (!selectedValue) return null;

    const radios = control.querySelectorAll('input[type="radio"]');
    for (const radio of radios) {
      if (radio.value === selectedValue) return radio;
    }

    return control.querySelector('input[type="radio"]:checked');
  }

  getCombinedProductURL(event) {
    if (event?.productUrl) {
      return event.productUrl;
    }

    if (event.target?.type === "hidden" && event.target?.dataset?.productUrl) {
      return event.target.dataset.productUrl;
    }

    if (event.target?.dataset?.productUrl) {
      return event.target.dataset.productUrl;
    }

    const control = event.target.closest(".product-form__controls");
    if (control) {
      const selectedInput = this.getSelectedOptionInput(control);
      if (selectedInput?.dataset?.productUrl) {
        return selectedInput.dataset.productUrl;
      }
    }

    for (const wrapper of this.querySelectorAll(".product-form__controls")) {
      const selectedInput = this.getSelectedOptionInput(wrapper);
      if (selectedInput?.dataset?.productUrl) {
        return selectedInput.dataset.productUrl;
      }
    }

    return "";
  }

  onVariantChange(event) {
    if (!this.contains(event.target)) return;

    this.variantUserInteracted = true;
    this.updateOptions();

    const combinedProductURL = this.getCombinedProductURL(event);
    const normalizedCombinedProductURL =
      this.normalizeProductUrl(combinedProductURL);
    const normalizedCurrentProductURL = this.normalizeProductUrl(
      this.dataset.url
    );
    const isCombinedProductSwitch =
      !!normalizedCombinedProductURL &&
      normalizedCombinedProductURL !== normalizedCurrentProductURL;
    const controls = [...this.querySelectorAll(".product-form__controls")];
    const changedOptionIndex = this.getChangedOptionIndex(event);
    const isLastOptionChange =
      controls.length <= 1 ||
      changedOptionIndex === -1 ||
      changedOptionIndex === controls.length - 1;

    if (isCombinedProductSwitch) {
      this.currentVariant = null;
      this.pendingCombinedProductURL = combinedProductURL;
      this.dataset.url = combinedProductURL;
      this.variantData = null;
      this.needsProductMediaRefresh = true;
      this.updateURL(combinedProductURL);
    } else {
      this.updateMasterId();
      if (!combinedProductURL) {
        this.pendingCombinedProductURL = "";
      }
    }

    this.isHighVariantNeedUpdate = false;
    this.isCombinedListingsNeedUpdate = false;
    this.pickerUpdateMode = "none";

    const hasStaleVariantSelection = this.hasStaleVariantSelection();

    const needsVariantResolve =
      (isCombinedProductSwitch || this.isHighVariantProduct()) &&
      (!this.currentVariant || hasStaleVariantSelection);
    const needsPickerAvailabilityUpdate =
      this.isHighVariantProduct() &&
      !isCombinedProductSwitch &&
      !isLastOptionChange &&
      changedOptionIndex >= 0;
    const needsPickerFullUpdate =
      isCombinedProductSwitch || needsVariantResolve;

    const canUseFastVariantUpdate =
      !isCombinedProductSwitch &&
      !!this.currentVariant &&
      (!this.isHighVariantProduct() ||
        (isLastOptionChange &&
          this.variantMatchesSelectedOptions(this.currentVariant)));

    if (needsPickerFullUpdate || needsPickerAvailabilityUpdate) {
      if (isCombinedProductSwitch || hasStaleVariantSelection) {
        this.currentVariant = null;
      }

      this.pickerUpdateMode = needsPickerFullUpdate ? "full" : "availability";
      this.highVariantRequestUrl = this.buildServerVariantRequestUrl(
        combinedProductURL,
        {
          preferOptionValues:
            needsPickerAvailabilityUpdate && !isCombinedProductSwitch,
        }
      );

      if (needsPickerFullUpdate || needsPickerAvailabilityUpdate) {
        this.isHighVariantNeedUpdate = true;
        if (combinedProductURL || isCombinedProductSwitch) {
          this.isCombinedListingsNeedUpdate = true;
        }
      }
    }

    if (!this.isHighVariantNeedUpdate) {
      this.updatePickupAvailability();
      this.updateVariantStatuses();
      this.syncAddToCartState();
    }
    this.resetErrorMessage();

    if (this.isHighVariantNeedUpdate) {
      this.classList.add("high-variant-loading");
      if (
        this.currentVariant &&
        canUseFastVariantUpdate &&
        !needsPickerAvailabilityUpdate
      ) {
        this.syncAddToCartState();
      } else {
        this.setAddToCartPending(true);
      }
      this.renderProductInfo(this.highVariantRequestUrl, {
        expectedProductUrl:
          this.pendingCombinedProductURL ||
          combinedProductURL ||
          this.dataset.url,
        forceMediaUpdate: this.needsProductMediaRefresh,
        updateBuyButtons:
          this.pickerUpdateMode === "full" || this.isCombinedListingsNeedUpdate,
        isHighVariantFetch: true,
        pickerUpdateMode: this.pickerUpdateMode,
        isCombinedFetch: this.isCombinedListingsNeedUpdate,
      });
      return;
    }

    if (!this.currentVariant) {
      this.syncAddToCartState();
      return;
    }

    if (canUseFastVariantUpdate) {
      this.updateMediaForCurrentVariant();
      this.updateURL();
      this.syncAddToCartState();
      this.updatePickupAvailability();
      this.renderProductInfo(
        this.createRequestUrl({
          currentVariantId: this.currentVariant.id,
        }),
        {
          pickerUpdateMode: "none",
          forceMediaUpdate: this.dataset?.variantMediaDisplay !== "show_all",
          updateBuyButtons: false,
          isHighVariantFetch: false,
          isCombinedFetch: false,
        }
      );
      return;
    }

    this.updateMediaForCurrentVariant();
    this.updateURL();
    this.syncAddToCartState();
    this.renderProductInfo(
      this.createRequestUrl({
        currentVariantId: this.currentVariant.id,
      }),
      {
        forceMediaUpdate: this.dataset?.variantMediaDisplay !== "show_all",
        updateBuyButtons: false,
        isHighVariantFetch: false,
        isCombinedFetch: false,
      }
    );
  }

  shouldForceMediaUpdateFromFetch(options = {}) {
    if (options.forceMediaUpdate === true || this.needsProductMediaRefresh) {
      return true;
    }

    return this.dataset?.variantMediaDisplay !== "show_all";
  }

  getSelectedOptionValue(control) {
    const dropdown = control.querySelector("variant-dropdown-select");
    if (dropdown) {
      const checked = dropdown.querySelector('input[type="radio"]:checked');
      if (checked?.value) return checked.value;

      const hidden = dropdown.querySelector("input[type='hidden']");
      if (hidden?.value) return hidden.value;
    }

    const checked = control.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;

    const select = control.querySelector("select");
    if (select) return select.value;

    return null;
  }

  getSortedOptionControls() {
    return [...this.querySelectorAll(".product-form__controls")].sort(
      (a, b) =>
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
    );
  }

  updateOptions() {
    this.options = this.getSortedOptionControls().map((control) =>
      this.getSelectedOptionValue(control)
    );
  }

  getSelectedVariantFromScript() {
    const el = this.querySelector("[data-selected-variant]");
    if (!el?.textContent?.trim()) return null;

    try {
      const variant = JSON.parse(el.textContent);
      return variant?.id ? variant : null;
    } catch {
      return null;
    }
  }

  variantMatchesSelectedOptions(variant) {
    if (!variant?.options?.length || !this.options?.length) return false;

    return variant.options.every(
      (option, index) => this.options[index] === option
    );
  }

  hasResolvedVariantForSelectedOptions(variant = this.currentVariant) {
    if (!variant?.id) return false;
    if (this.variantMatchesSelectedOptions(variant)) return true;

    if (!this.isHighVariantProduct() && !this.getSelectedExternalProductURL()) {
      return false;
    }

    const fromScript = this.getSelectedVariantFromScript();
    return !!fromScript?.id && String(fromScript.id) === String(variant.id);
  }

  hasStaleVariantSelection() {
    if (this.hasCombinedListingOptions()) return false;
    if (!this.variantUserInteracted || !this.isHighVariantProduct())
      return false;

    this.updateOptions();
    const variant = this.currentVariant || this.getSelectedVariantFromScript();
    return !!variant?.id && !this.variantMatchesSelectedOptions(variant);
  }

  findVariantBySelectedOptions() {
    if (!this.querySelector("[data-all-variants-no-high]")) return null;
    // Only high-variant products and selections that point to a different
    // linked product must resolve from server/script.
    if (this.isHighVariantProduct() || this.getSelectedExternalProductURL()) {
      return null;
    }

    const variantData = this.getVariantData();
    if (!variantData?.length) return null;

    return (
      variantData.find((variant) =>
        variant.options?.every(
          (option, index) => this.options[index] === option
        )
      ) || null
    );
  }

  updateMasterId() {
    const matched = this.findVariantBySelectedOptions();
    if (matched) {
      this.currentVariant = matched;
      return;
    }

    if (!this.isHighVariantProduct() && !this.getSelectedExternalProductURL()) {
      this.currentVariant = undefined;
      return;
    }

    const fromScript = this.getSelectedVariantFromScript();
    if (fromScript?.id) {
      if (
        this.variantMatchesSelectedOptions(fromScript) ||
        this.shouldTrustSelectedVariantFromScript()
      ) {
        this.currentVariant = fromScript;
        return;
      }
    }

    if (!this.isHighVariantProduct()) {
      this.currentVariant = undefined;
      return;
    }

    if (
      this.currentVariant?.id &&
      !this.variantMatchesSelectedOptions(this.currentVariant)
    ) {
      this.currentVariant = undefined;
    }
  }

  getVariantFeaturedMediaId(variant = this.currentVariant) {
    if (!variant?.featured_media?.id) return null;
    return String(variant.featured_media.id);
  }

  findSlideIndexByVariantFeaturedImage(sliderEl, variant, sectionId) {
    if (!sliderEl?.swiper || !variant) return -1;

    const mediaId = this.getVariantFeaturedMediaId(variant);
    if (mediaId) {
      const byMediaId = findProductMediaSlideIndex(
        sliderEl,
        mediaId,
        sectionId
      );
      if (byMediaId >= 0) return byMediaId;
    }

    const imageSrc =
      variant.featured_image?.src ||
      variant.featured_media?.preview_image?.src ||
      variant.featured_media?.preview?.src;
    if (!imageSrc) return -1;

    const normalizedSrc = imageSrc.split("?")[0];
    const fileName = normalizedSrc.split("/").pop();

    return sliderEl.swiper.slides.findIndex((slide) => {
      const img = slide.querySelector("img[src]");
      if (!img?.src) return false;
      const slideSrc = img.src.split("?")[0];
      return (
        slideSrc === normalizedSrc || (fileName && slideSrc.includes(fileName))
      );
    });
  }

  shouldUpdateMediaBySliding() {
    return this.dataset?.variantMediaDisplay === "show_all";
  }

  updateMediaForCurrentVariant() {
    if (!this.shouldUpdateMediaBySliding()) return;
    this.updateMedia(this.getVariantFeaturedMediaId(), this.currentVariant);
  }

  updateMedia(mediaId, variant = this.currentVariant) {
    const sectionId = this.dataset.section;
    const mediaEl = this.getProductMediaContainer();
    if (!mediaEl) return;

    const sliderEl = mediaEl.querySelector(".js-media-list");
    if (!sliderEl) return;

    const navigate = () => {
      if (!sliderEl.swiper) return false;

      let slideIndex = -1;

      if (mediaId) {
        const rawMediaId = String(mediaId).includes("-")
          ? String(mediaId).split("-").pop()
          : String(mediaId);
        slideIndex = findProductMediaSlideIndex(
          sliderEl,
          rawMediaId,
          sectionId
        );
        if (slideIndex < 0) {
          slideIndex = findProductMediaSlideIndex(sliderEl, mediaId, null);
        }
      }

      if (slideIndex < 0 && variant) {
        slideIndex = this.findSlideIndexByVariantFeaturedImage(
          sliderEl,
          variant,
          sectionId
        );
      }

      if (slideIndex < 0) return false;

      sliderEl.swiper.slideTo(slideIndex, 800);
      syncPopupSliderToMain();
      return true;
    };

    if (navigate()) return;
    requestAnimationFrame(() => navigate());
  }

  updateURL(productUrl = "") {
    if (this.dataset.updateUrl === "false") return;
    const baseUrl =
      productUrl || this.pendingCombinedProductURL || this.dataset.url;
    const newUrl = this.currentVariant?.id
      ? `${baseUrl}?variant=${this.currentVariant.id}`
      : baseUrl;

    window.history.replaceState({}, "", newUrl);
  }

  getResolvedVariantId() {
    if (this.currentVariant?.id) return String(this.currentVariant.id);
    const form = this.getProductFormElements()[0];
    return form?.querySelector('input[name="id"]')?.value?.trim() || "";
  }

  isVariantValidForCart() {
    if (this.productInfoLoading) return false;

    this.updateOptions();

    const matched = this.findVariantBySelectedOptions();
    if (matched?.id) {
      this.currentVariant = matched;
      return matched.available !== false;
    }

    if (this.isHighVariantProduct() || this.getSelectedExternalProductURL()) {
      const variant =
        this.currentVariant || this.getSelectedVariantFromScript();
      if (!variant?.id) return false;
      this.currentVariant = variant;
      return variant.available !== false;
    }

    if (this.querySelector("[data-all-variants-no-high]")) {
      return false;
    }

    const fromScript = this.getSelectedVariantFromScript();
    if (fromScript?.id && this.variantMatchesSelectedOptions(fromScript)) {
      this.currentVariant = fromScript;
      return fromScript.available !== false;
    }

    const variantId = this.getResolvedVariantId();
    if (!variantId) return false;

    if (this.currentVariant?.id) {
      return this.currentVariant.available !== false;
    }

    const form = this.getProductFormElements()[0];
    const input = form?.querySelector('input[name="id"]');
    return !!(input?.value?.trim() && !input.disabled);
  }

  syncQuantityInputsForVariant(variant = this.currentVariant) {
    if (!variant?.available) return;

    this.getProductFormElements().forEach((form) => {
      const quantityInput = form.querySelector('input[name="quantity"]');
      if (!quantityInput) return;

      const quantityEl = quantityInput.closest("quantity-input");
      const min = Math.max(
        1,
        Number(
          quantityInput.getAttribute("min") || quantityInput.dataset?.min || 1
        )
      );
      const currentQty = Number(quantityInput.value);

      if (!currentQty || currentQty < min) {
        quantityInput.value = String(min);
      }

      quantityInput.removeAttribute("disabled");
      quantityEl?.classList.remove("disabled");

      if (quantityEl && typeof quantityEl.setMinimumDisable === "function") {
        quantityEl.setMinimumDisable();
      }
    });
  }

  getProductFormElements() {
    const forms = new Set();
    const sectionId = this.dataset.section;
    const quickAddModal = this.closest("quick-add-modal");
    const searchRoot = quickAddModal || document;
    const allowedFormIds = new Set([
      `product-form-${sectionId}`,
      `product-form-floating-${sectionId}`,
      `product-form-installment-${sectionId}`,
    ]);

    searchRoot
      .querySelectorAll(
        `#product-form-${sectionId}, #product-form-floating-${sectionId}, #product-form-installment-${sectionId}`
      )
      .forEach((form) => forms.add(form));

    const sectionEl = this.getProductSectionElement(sectionId);

    sectionEl
      ?.querySelectorAll('form[data-type="add-to-cart-form"]')
      .forEach((form) => {
        const parentProductForm = form.closest("product-form");
        const source = parentProductForm?.dataset?.source;
        const isOwnedByCurrentPicker =
          allowedFormIds.has(form.id) ||
          source === sectionId ||
          source === `${sectionId}-floating`;

        if (isOwnedByCurrentPicker) {
          forms.add(form);
        }
      });

    return [...forms];
  }

  setVariantFormInputs({ disabled = false, variantId = "" } = {}) {
    this.getProductFormElements().forEach((form) => {
      const input = form.querySelector('input[name="id"]');
      if (!input) return;
      input.disabled = disabled;
      input.value = variantId;
    });
  }

  restoreProductInfoVisibility() {
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );

    if (price) price.classList.remove("visibility-hidden");
    if (inventory) inventory.classList.remove("visibility-hidden");
  }

  setAddToCartPending(isPending) {
    this.getProductFormElements().forEach((form) => {
      const addButton = form.querySelector('[name="add"]');
      if (!addButton) return;

      if (isPending) {
        addButton.setAttribute("disabled", true);
        addButton.setAttribute("aria-disabled", true);
        addButton.dataset.status = "loading";
        return;
      }

      if (addButton.dataset.status === "loading") {
        addButton.dataset.status = "available";
      }
      addButton.removeAttribute("disabled");
      addButton.removeAttribute("aria-disabled");
      addButton.classList.remove("loading");
    });
  }

  clearProductFormSubmitLoading() {
    const sectionId = this.dataset.section;
    document
      .querySelectorAll(
        `product-form[data-source="${sectionId}"], product-form[data-source="${sectionId}-floating"]`
      )
      .forEach((productForm) => {
        if (typeof productForm.setSubmitLoading === "function") {
          productForm.setSubmitLoading(false);
        }
      });
  }

  syncAddToCartState() {
    this.updateOptions();

    const fromScript = this.getSelectedVariantFromScript();
    const selectedExternalProductURL = this.getSelectedExternalProductURL();

    if (selectedExternalProductURL || this.isHighVariantProduct()) {
      if (fromScript?.id) {
        this.currentVariant = fromScript;
      } else {
        this.updateMasterId();
      }
    } else {
      const matched = this.findVariantBySelectedOptions();
      if (matched) {
        this.currentVariant = matched;
      } else {
        this.updateMasterId();
      }
    }

    if (!this.currentVariant) {
      if (this.productInfoLoading) {
        this.setAddToCartPending(true);
      } else {
        this.setUnavailable();
      }
      return;
    }

    if (
      !this.hasResolvedVariantForSelectedOptions(this.currentVariant) &&
      this.variantUserInteracted
    ) {
      if (this.productInfoLoading) {
        this.setAddToCartPending(true);
      } else {
        this.setUnavailable();
      }
      return;
    }

    this.restoreProductInfoVisibility();
    this.clearProductFormSubmitLoading();

    if (this.currentVariant.available === false) {
      this.setVariantFormInputs({
        disabled: true,
        variantId: String(this.currentVariant.id),
      });
      this.updateSkuDisplay(this.currentVariant);
      this.toggleAddButton(true, window.variantStrings.soldOut);
      return;
    }

    this.setVariantFormInputs({
      disabled: false,
      variantId: String(this.currentVariant.id),
    });
    this.syncQuantityInputsForVariant(this.currentVariant);
    this.toggleAddButton(false);
    this.updateSkuDisplay(this.currentVariant);

    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        sectionId: this.dataset.section,
        variant: this.currentVariant,
      },
    });
  }

  updateVariantInput() {
    this.syncAddToCartState();
  }

  updateVariantStatuses() {
    if (this.isHighVariantProduct()) return;

    const variantData = this.getVariantData();
    if (!variantData?.length) return;

    const inputWrappers = this.getSortedOptionControls();
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const availableOptionInputsValue = variantData
        .filter((variant) => {
          return inputWrappers
            .slice(0, index)
            .every(
              (wrapper, optionIndex) =>
                this.getSelectedOptionValue(wrapper) ===
                variant.options[optionIndex]
            );
        })
        .filter((variant) => variant.available)
        .map((variantOption) => variantOption.options[index]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setOptionInputVisualState(input, isAvailable, optionValue) {
    const listItem = input.closest("li");

    if (input.tagName === "OPTION") {
      input.innerText = isAvailable
        ? optionValue
        : window.variantStrings.unavailable_with_option.replace(
            "[value]",
            optionValue
          );
      input.disabled = false;
      return;
    }

    if (input.tagName === "INPUT") {
      const isAlwaysClickable = !!input.dataset.productUrl;
      input.classList.toggle("disabled", !isAvailable);

      if (!isAvailable) {
        if (isAlwaysClickable) {
          input.classList.add("always-clickable");
          listItem?.classList.add("always-clickable");
        } else {
          input.classList.remove("always-clickable");
          listItem?.classList.remove("always-clickable");
        }
        input.removeAttribute("disabled");
        input.setAttribute("aria-disabled", "true");
        listItem?.setAttribute("aria-disabled", "true");
        listItem?.classList.add("disabled");
      } else {
        input.removeAttribute("disabled");
        input.removeAttribute("aria-disabled");
        input.classList.remove("always-clickable");
        listItem?.classList.remove("disabled");
        listItem?.classList.remove("always-clickable");
        listItem?.removeAttribute("aria-disabled");
      }
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const optionValue = input.getAttribute("value");
      const isAvailable = listOfAvailableOptions.includes(optionValue);
      this.setOptionInputVisualState(input, isAvailable, optionValue);
    });
  }

  setCheckedInputsBySelectedValues(selectedValues) {
    const inputWrappers = [...this.querySelectorAll(".product-form__controls")];

    inputWrappers.forEach((groupEl, index) => {
      const selectedValue = selectedValues[index];
      if (!selectedValue) return;

      const inputs = [...groupEl.querySelectorAll('input[type="radio"]')];

      inputs.forEach((input) => {
        const shouldBeChecked = input.value === selectedValue;
        input.checked = shouldBeChecked;
        if (shouldBeChecked) {
          input.setAttribute("checked", "");
        } else {
          input.removeAttribute("checked");
        }
      });
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  isStaleProductInfoRequest(requestId) {
    return requestId !== this.productInfoRequestId;
  }

  renderProductInfo(requestUrl, options = {}) {
    if (!requestUrl) {
      this.productInfoLoading = false;
      this.classList.remove("high-variant-loading");
      this.syncAddToCartState();
      return;
    }

    this.productInfoPriceUpdated = false;

    const fetchOptions = {
      pickerUpdateMode:
        options.pickerUpdateMode || this.pickerUpdateMode || "none",
      isHighVariantFetch: options.isHighVariantFetch === true,
      isCombinedFetch: options.isCombinedFetch === true,
      forceMediaUpdate: options.forceMediaUpdate,
      updateBuyButtons: options.updateBuyButtons,
      expectedProductUrl:
        options.expectedProductUrl ||
        this.pendingCombinedProductURL ||
        this.dataset.url,
    };

    this.abortController?.abort();
    this.abortController = new AbortController();
    const signal = this.abortController.signal;
    const requestId = ++this.productInfoRequestId;
    this.productInfoLoading = true;
    if (!this.currentVariant?.id) {
      this.setAddToCartPending(true);
    }

    fetch(requestUrl, { signal })
      .then((response) => response.text())
      .then(async (responseText) => {
        if (this.isStaleProductInfoRequest(requestId)) return;

        if (fetchOptions.expectedProductUrl) {
          this.dataset.url = fetchOptions.expectedProductUrl;
        }

        const html = new DOMParser().parseFromString(responseText, "text/html");

        this.syncPickerDatasetFromHtml(html);

        if (this.isStaleProductInfoRequest(requestId)) return;

        // -----
        // for high-variant products
        // and if variant not found in liquid <script data-all-variants-no-high>
        // but it was found after a request with the option_values parameter
        const pickerUpdateMode = fetchOptions.pickerUpdateMode;

        if (fetchOptions.isHighVariantFetch) {
          try {
            this.variantData = null;
            this.updateURL();
            this.updatePickupAvailability();
            if (pickerUpdateMode === "full") {
              this.updatePickerInnerHtml(html);
              this.setCurrentVariantAfterFetch(html);
            } else {
              this.updatePickerAvailabilityFromHtml(html);
              try {
                this.setCurrentVariantAfterFetch(html);
              } catch (err) {}
            }
            if (this.currentVariant) {
              this.syncAddToCartState();
              if (!fetchOptions.isCombinedFetch) {
                this.updateMediaForCurrentVariant();
              }
            }
          } catch (err) {}
        } else if (this.querySelector("[data-all-variants-no-high]")) {
          this.updateVariantStatuses();
        }
        // -----

        let mediaHtml = html;
        const sourceSectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;
        const forceMediaUpdate =
          this.shouldForceMediaUpdateFromFetch(fetchOptions);
        const mediaSlideCount = this.countMediaSlidesInHtml(
          html,
          sourceSectionId
        );
        const needsSecondMediaFetch =
          forceMediaUpdate &&
          this.currentVariant?.id &&
          mediaSlideCount === 1 &&
          this.hasRealProductGalleryInHtml(html, sourceSectionId);

        if (needsSecondMediaFetch) {
          const variantMediaUrl = this.createRequestUrl({
            currentVariantId: this.currentVariant.id,
            combinedProductURL: fetchOptions.expectedProductUrl,
          });
          if (variantMediaUrl) {
            try {
              const variantResponse = await fetch(variantMediaUrl, { signal });
              if (this.isStaleProductInfoRequest(requestId)) return;
              if (variantResponse.ok) {
                mediaHtml = new DOMParser().parseFromString(
                  await variantResponse.text(),
                  "text/html"
                );
              }
            } catch (err) {
              if (err.name !== "AbortError") {
                console.error(err);
              }
            }
          }
        }

        if (this.isStaleProductInfoRequest(requestId)) return;

        const shouldUpdateBuyButtons =
          fetchOptions.updateBuyButtons === true ||
          (fetchOptions.updateBuyButtons !== false &&
            (pickerUpdateMode === "full" || fetchOptions.isCombinedFetch));

        this.updateElementsAfterFetch(html, mediaHtml, {
          forceMediaUpdate,
          updateBuyButtons: shouldUpdateBuyButtons,
          isCombinedFetch: fetchOptions.isCombinedFetch,
        });

        if (forceMediaUpdate) {
          this.needsProductMediaRefresh = false;
        }

        try {
          this.setCurrentVariantAfterFetch(html);
        } catch (err) {}

        this.updateURL();
        this.reinitDropdownSelects();
        this.updateMediaForCurrentVariant();
        this.syncAddToCartState();
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.info("Fetch aborted by user");
        } else {
          console.error(error);
        }
      })
      .finally(() => {
        if (!this.isStaleProductInfoRequest(requestId)) {
          this.productInfoLoading = false;
          this.classList.remove("high-variant-loading");
          this.pendingCombinedProductURL = "";
          this.setAddToCartPending(false);
          this.syncAddToCartState();
          if (this.productInfoPriceUpdated) {
            this.restoreProductInfoVisibility();
          }
          this.productInfoPriceUpdated = false;
        }
      });
  }

  toggleAddButton(disable = true, text) {
    this.getProductFormElements().forEach((form) => {
      const addButton = form.querySelector('[name="add"]');
      if (!addButton) return;

      const addButtonText =
        addButton.querySelector(".button__label") ||
        addButton.querySelector("span");

      if (disable) {
        addButton.setAttribute("disabled", true);
        addButton.setAttribute("aria-disabled", true);
        if (text && addButtonText) {
          addButtonText.textContent = text;

          if (text === window.variantStrings.unavailable) {
            addButton.dataset.status = "unavailable";
          } else if (text === window.variantStrings.soldOut) {
            addButton.dataset.status = "sold-out";
          }
        }
      } else {
        addButton.removeAttribute("disabled");
        addButton.removeAttribute("aria-disabled");
        addButton.classList.remove("loading");
        if (addButtonText) {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
        addButton.dataset.status = "available";
      }
    });
  }

  resetErrorMessage() {
    this.getProductFormElements().forEach((form) => {
      const parentEl = form.closest("product-form");
      if (parentEl) {
        const errorWrapperEl = parentEl.querySelector(
          ".product-form__error-message-wrapper"
        );
        const errorTextEl = errorWrapperEl?.querySelector(
          ".product-form__error-message"
        );
        if (!errorWrapperEl || !errorTextEl) return;
        errorWrapperEl.setAttribute("hidden", true);
        errorTextEl.textContent = "";
      }
    });
  }

  shouldHideProductInfoWhenUnavailable() {
    if (!this.variantUserInteracted) return false;
    if (this.productInfoLoading) return false;
    if (this.pendingCombinedProductURL) return false;
    if (this.hasStaleVariantSelection()) return false;
    if (this.productInfoPriceUpdated) return false;
    if (this.hasCombinedListingOptions()) return false;
    return true;
  }

  setUnavailable(options = {}) {
    const hideProductInfo =
      options.hideProductInfo ?? this.shouldHideProductInfoWhenUnavailable();

    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );

    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const colorNameDestinations = document.querySelectorAll(
      `[id^="ColorName-${this.dataset.section}"]`
    );

    this.toggleAddButton(true, window.variantStrings.unavailable);
    this.setVariantFormInputs({ disabled: true, variantId: "" });

    if (hideProductInfo) {
      if (price) price.classList.add("visibility-hidden");
      if (inventory) inventory.classList.add("visibility-hidden");
    } else {
      this.restoreProductInfoVisibility();
    }

    if (sku) this.clearSkuElement(sku);
    colorNameDestinations.forEach((colorNameDestination) => {
      colorNameDestination.classList.add("visibility-hidden");
    });
  }

  getVariantData() {
    const el = this.querySelector("[data-all-variants-no-high]");
    if (!el) {
      this.variantData = null;
      return [];
    }

    try {
      this.variantData = JSON.parse(el.textContent);
    } catch {
      this.variantData = null;
    }

    return this.variantData || [];
  }

  getProductSectionElement(sectionId) {
    const section =
      document.getElementById(`shopify-section-${sectionId}`) ||
      document.getElementById(`MainProduct-${sectionId}`);

    if (section) return section;

    const quickAddModal =
      document.querySelector("quick-add-modal[open]") ||
      document.querySelector("quick-add-modal");

    if (!quickAddModal) return null;

    return (
      quickAddModal
        .querySelector(`#ProductInfo-${sectionId}`)
        ?.closest(".product") ||
      quickAddModal
        .querySelector(
          `variant-selects[data-section="${sectionId}"], variant-radios[data-section="${sectionId}"]`
        )
        ?.closest(".product") ||
      quickAddModal.querySelector(".quick-add-modal__content-info")
    );
  }

  getProductMediaContainer(sectionId = this.dataset.section) {
    const sectionEl = this.getProductSectionElement(sectionId);
    return (
      sectionEl?.querySelector(`[data-section="product-media-${sectionId}"]`) ||
      document.querySelector(`[data-section="product-media-${sectionId}"]`)
    );
  }

  destroyProductMediaSwipers(root) {
    if (!root) return;
    root.querySelectorAll(".swiper").forEach((el) => {
      if (el.swiper) {
        el.swiper.destroy(true, true);
      }
    });
  }

  reinitProductMediaGalleries(sectionEl) {
    if (!sectionEl) return;
    if (typeof subSliderInit === "function") subSliderInit(sectionEl);
    if (typeof sliderInit === "function") sliderInit(sectionEl);
    if (typeof popupSliderInit === "function") popupSliderInit(sectionEl);
    if (typeof syncPopupSliderToMain === "function") syncPopupSliderToMain();
  }

  updateProductModalFromHtml(mediaHtml, sourceSectionId, currentSectionId) {
    const modalSource = mediaHtml.getElementById(
      `ProductModal-${sourceSectionId}`
    );
    const modalDestination = document.getElementById(
      `ProductModal-${currentSectionId}`
    );
    if (!modalDestination) return;

    const popupDestination = modalDestination.querySelector(".js-popup-slider");
    if (!modalSource) {
      if (popupDestination) {
        if (popupDestination.swiper) {
          popupDestination.swiper.destroy(true, true);
        }
        popupDestination.querySelector(".swiper-wrapper")?.replaceChildren();
      }
      modalDestination.querySelector(".product__pagination-wrapper")?.remove();
      modalDestination.querySelector(".product__slider-nav")?.remove();
      return;
    }

    const popupSource = modalSource.querySelector(".js-popup-slider");
    if (popupSource && popupDestination) {
      if (popupDestination.swiper) {
        popupDestination.swiper.destroy(true, true);
      }
      popupDestination.innerHTML = popupSource.innerHTML;
    } else if (popupDestination) {
      if (popupDestination.swiper) {
        popupDestination.swiper.destroy(true, true);
      }
      popupDestination.querySelector(".swiper-wrapper")?.replaceChildren();
    }

    const paginationSource = modalSource.querySelector(
      ".product__pagination-wrapper"
    );
    const paginationDestination = modalDestination.querySelector(
      ".product__pagination-wrapper"
    );
    if (paginationSource && paginationDestination) {
      paginationDestination.innerHTML = paginationSource.innerHTML;
    } else if (paginationSource && !paginationDestination) {
      modalDestination.appendChild(paginationSource.cloneNode(true));
    } else if (!paginationSource && paginationDestination) {
      paginationDestination.remove();
    }

    const navSource = modalSource.querySelector(".product__slider-nav");
    const navDestination = modalDestination.querySelector(
      ".product__slider-nav"
    );
    if (navSource && navDestination) {
      navDestination.innerHTML = navSource.innerHTML;
    } else if (navSource && !navDestination) {
      modalDestination.appendChild(navSource.cloneNode(true));
    } else if (!navSource && navDestination) {
      navDestination.remove();
    }
  }

  syncProductMediaLayoutClass(sectionEl, mediaHtml) {
    const sourceProduct = mediaHtml.querySelector(".product");
    const destProduct = sectionEl?.querySelector(".product");
    if (!sourceProduct || !destProduct) return;

    destProduct.classList.toggle(
      "product--no-media",
      sourceProduct.classList.contains("product--no-media")
    );
    destProduct.classList.toggle(
      "row",
      sourceProduct.classList.contains("row")
    );
  }

  getGiftCardRecipientWrapper(root, sectionId) {
    if (!root) return null;

    return (
      root.getElementById?.(`GiftCardRecipient-${sectionId}`) ||
      root.querySelector?.(`#GiftCardRecipient-${sectionId}`)
    );
  }

  getLegacyGiftCardRecipientContainer(formEl) {
    const recipientForm = formEl?.querySelector("recipient-form");
    if (!recipientForm) return null;
    return recipientForm.closest(".customer") || recipientForm;
  }

  getFloatingProductBar(root, sectionId) {
    if (!root) return null;

    return (
      root.getElementById?.(`FloatingProductBar-${sectionId}`) ||
      root.querySelector?.(`#FloatingProductBar-${sectionId}`) ||
      root.querySelector?.(".product__media_navigation")
    );
  }

  replaceSectionIdsInMarkup(markup, sourceSectionId, currentSectionId) {
    if (!markup || sourceSectionId === currentSectionId) return markup;
    return markup.replaceAll(sourceSectionId, currentSectionId);
  }

  rewriteFetchedNodeMarkup(markup, sourceSectionId, currentSectionId) {
    if (!markup) return markup;

    if (this.needsSectionIdRewrite()) {
      return this.rewriteFetchedMarkupForSection(
        markup,
        sourceSectionId,
        currentSectionId
      );
    }

    if (sourceSectionId !== currentSectionId) {
      return this.replaceSectionIdsInMarkup(
        markup,
        sourceSectionId,
        currentSectionId
      );
    }

    return markup;
  }

  updateLinkedProductsFromHtml(html, sourceSectionId, currentSectionId) {
    const productInfoSource = this.getProductInfoFromHtml(
      html,
      sourceSectionId
    );
    const productInfoDestination = document.getElementById(
      `ProductInfo-${currentSectionId}`
    );
    if (!productInfoDestination) return;

    const variantPickerSelector = `#variant-picker-${currentSectionId}`;
    const syncLinkedProductsBlock = (selector, insertAfterVariantPicker) => {
      const source = productInfoSource?.querySelector(selector);
      const destination = productInfoDestination.querySelector(selector);

      if (source && destination) {
        destination.outerHTML = this.rewriteFetchedNodeMarkup(
          source.outerHTML,
          sourceSectionId,
          currentSectionId
        );
        return;
      }

      if (source && !destination) {
        const variantPicker = productInfoDestination.querySelector(
          variantPickerSelector
        );
        const markup = this.rewriteFetchedNodeMarkup(
          source.outerHTML,
          sourceSectionId,
          currentSectionId
        );

        if (variantPicker) {
          variantPicker.insertAdjacentHTML(
            insertAfterVariantPicker ? "afterend" : "beforebegin",
            markup
          );
        } else {
          productInfoDestination.insertAdjacentHTML("beforeend", markup);
        }
        return;
      }

      if (!source && destination) {
        destination.remove();
      }
    };

    // `product-linked-products` renders before the variant picker.
    syncLinkedProductsBlock(".linked-products", false);
    // `linked-products` renders after the variant picker.
    syncLinkedProductsBlock(".product-parameters--linked-products", true);
    // `complementary` uses the product recommendations endpoint and also needs
    // to be replaced when switching to another combined product.
    syncLinkedProductsBlock(
      "product-recommendations.complementary-products",
      true
    );
  }

  updateFloatingProductBarFromHtml(html, sourceSectionId, currentSectionId) {
    const sectionSource =
      html.getElementById(`shopify-section-${sourceSectionId}`) || html;
    const sectionDest = this.getProductSectionElement(currentSectionId);
    const sourceBar = this.getFloatingProductBar(
      sectionSource,
      sourceSectionId
    );
    const destBar = this.getFloatingProductBar(sectionDest, currentSectionId);

    if (!destBar || !sourceBar) return;

    const sourceTitle = sourceBar.querySelector(
      ".product__media_navigation-title"
    );
    const destTitle = destBar.querySelector(".product__media_navigation-title");
    if (sourceTitle && destTitle) {
      destTitle.innerHTML = sourceTitle.innerHTML;
    }

    const sourceBtn = sourceBar.querySelector(".product__media_navigation-btn");
    const destBtn = destBar.querySelector(".product__media_navigation-btn");
    if (sourceBtn && destBtn) {
      destBtn.innerHTML = this.replaceSectionIdsInMarkup(
        sourceBtn.innerHTML,
        sourceSectionId,
        currentSectionId
      );
    }
  }

  updateGiftCardRecipientFromHtml(html, sourceSectionId, currentSectionId) {
    const sourceForm = html.getElementById(`product-form-${sourceSectionId}`);
    const destForm = document.getElementById(
      `product-form-${currentSectionId}`
    );
    const sourceProductForm =
      sourceForm?.closest("product-form") ||
      html.querySelector(`#ProductInfo-${sourceSectionId} product-form`);
    const destProductForm = destForm?.closest("product-form");

    if (sourceProductForm && destProductForm) {
      destProductForm.dataset.hideErrors = sourceProductForm.dataset.hideErrors;
    }

    let sourceWrapper = this.getGiftCardRecipientWrapper(html, sourceSectionId);
    let destWrapper = this.getGiftCardRecipientWrapper(
      document,
      currentSectionId
    );

    if (!sourceWrapper && sourceForm) {
      sourceWrapper = this.getLegacyGiftCardRecipientContainer(sourceForm);
    }

    if (!destWrapper && destForm) {
      destWrapper = this.getLegacyGiftCardRecipientContainer(destForm);
    }

    const insertAnchor = destForm?.querySelector(".product-form__buttons");

    const cloneWrapperHtml = (wrapper) => {
      let markup = wrapper.outerHTML;
      if (sourceSectionId !== currentSectionId) {
        markup = markup.replaceAll(sourceSectionId, currentSectionId);
      }
      const template = document.createElement("template");
      template.innerHTML = markup.trim();
      return template.content.firstElementChild;
    };

    if (sourceWrapper && destWrapper) {
      if (sourceSectionId !== currentSectionId) {
        destWrapper.replaceWith(cloneWrapperHtml(sourceWrapper));
      } else {
        destWrapper.innerHTML = sourceWrapper.innerHTML;
      }
      return;
    }

    if (sourceWrapper && !destWrapper && insertAnchor) {
      const clone = cloneWrapperHtml(sourceWrapper);
      if (clone) insertAnchor.before(clone);
      return;
    }

    if (!sourceWrapper && destWrapper) {
      destWrapper.remove();
    }
  }

  updateProductTitleAndBadgesFromHtml(
    productInfoSource,
    productInfoDestination,
    sourceSectionId,
    currentSectionId
  ) {
    if (!productInfoSource || !productInfoDestination) return;

    const wrapperSources = productInfoSource.querySelectorAll(
      ".product__title__wrapper"
    );
    const wrapperDestinations = productInfoDestination.querySelectorAll(
      ".product__title__wrapper"
    );

    if (
      wrapperSources.length &&
      wrapperDestinations.length &&
      wrapperSources.length === wrapperDestinations.length
    ) {
      wrapperDestinations.forEach((wrapperDestination, index) => {
        let wrapperHtml = wrapperSources[index].innerHTML;
        if (this.needsSectionIdRewrite()) {
          wrapperHtml = this.rewriteFetchedMarkupForSection(
            wrapperHtml,
            sourceSectionId,
            currentSectionId
          );
        }
        wrapperDestination.innerHTML = wrapperHtml;
        wrapperDestination.className = wrapperSources[index].className;
      });
      return;
    }

    const titleSources = productInfoSource.querySelectorAll(".product__title");
    const titleDestinations =
      productInfoDestination.querySelectorAll(".product__title");
    if (
      titleSources.length &&
      titleDestinations.length &&
      titleSources.length === titleDestinations.length
    ) {
      titleDestinations.forEach((titleDestination, index) => {
        titleDestination.innerHTML = titleSources[index].innerHTML;
      });
    }
  }

  getSkuDisplayText(skuEl) {
    if (!skuEl) return "";
    const clone = skuEl.cloneNode(true);
    clone.querySelectorAll(".visually-hidden").forEach((node) => node.remove());
    return clone.textContent.trim();
  }

  clearSkuElement(skuEl) {
    if (!skuEl) return;
    const label = skuEl.querySelector(".visually-hidden");
    skuEl.innerHTML = label ? label.outerHTML : "";
    skuEl.classList.add("visibility-hidden");
  }

  updateSkuDisplay(variant) {
    const skuEl = document.getElementById(`Sku-${this.dataset.section}`);
    if (!skuEl) return;

    const label = skuEl.querySelector(".visually-hidden");
    const skuValue = (variant?.sku || "").trim();

    if (!skuValue) {
      this.clearSkuElement(skuEl);
      return;
    }

    skuEl.innerHTML = (label ? label.outerHTML : "") + skuValue;
    skuEl.classList.remove("visibility-hidden");
  }

  updateProductSkuFromHtml(html, sourceSectionId, currentSectionId) {
    const htmlRoot = this.getMediaHtmlRoot(html, sourceSectionId);
    const skuSource = htmlRoot.querySelector(`#Sku-${sourceSectionId}`);
    const skuDestination = document.getElementById(`Sku-${currentSectionId}`);

    if (!skuDestination) return;

    if (!skuSource) {
      this.clearSkuElement(skuDestination);
      return;
    }

    skuDestination.innerHTML = skuSource.innerHTML;
    skuDestination.className = skuSource.className;

    if (
      skuSource.classList.contains("visibility-hidden") ||
      !this.getSkuDisplayText(skuSource)
    ) {
      this.clearSkuElement(skuDestination);
    }
  }

  updateProductDescriptionFromHtml(html, sourceSectionId, currentSectionId) {
    const descriptionSource = html.getElementById(
      `ProductDescription-${sourceSectionId}`
    );
    let descriptionDestination = document.getElementById(
      `ProductDescription-${currentSectionId}`
    );

    if (!descriptionDestination) {
      descriptionDestination = document
        .getElementById(`ProductInfo-${currentSectionId}`)
        ?.querySelector(".product__description");
    }

    if (descriptionSource && descriptionDestination) {
      descriptionDestination.innerHTML = descriptionSource.innerHTML;
      descriptionDestination.className = descriptionSource.className;
      descriptionDestination.hidden = descriptionSource.hidden;
      if (!descriptionDestination.id) {
        descriptionDestination.id = `ProductDescription-${currentSectionId}`;
      }
      return;
    }

    if (!descriptionSource && descriptionDestination) {
      descriptionDestination.innerHTML = "";
      descriptionDestination.classList.add("hidden");
      descriptionDestination.hidden = true;
      return;
    }

    if (descriptionSource && !descriptionDestination) {
      const productInfoDestination = document.getElementById(
        `ProductInfo-${currentSectionId}`
      );
      const insertAfter = this.findProductInfoBlockAnchor(
        descriptionSource,
        html.getElementById(`ProductInfo-${sourceSectionId}`),
        productInfoDestination,
        sourceSectionId,
        currentSectionId
      );
      const clone = descriptionSource.cloneNode(true);
      clone.id = `ProductDescription-${currentSectionId}`;
      if (insertAfter) {
        insertAfter.after(clone);
      } else {
        productInfoDestination?.prepend(clone);
      }
    }
  }

  updateProductTagsFromHtml(html, sourceSectionId, currentSectionId) {
    const productInfoSource = this.getProductInfoFromHtml(html, sourceSectionId);
    const productInfoDestination = document.getElementById(
      `ProductInfo-${currentSectionId}`
    );
    if (!productInfoDestination) return;

    const tagsSelector = ".product-tags.product__tags";
    const tagsSource = productInfoSource?.querySelector(tagsSelector);
    const tagsDestination = productInfoDestination.querySelector(tagsSelector);

    if (tagsSource && tagsDestination) {
      tagsDestination.outerHTML = this.rewriteFetchedNodeMarkup(
        tagsSource.outerHTML,
        sourceSectionId,
        currentSectionId
      );
      return;
    }

    if (!tagsSource && tagsDestination) {
      tagsDestination.remove();
      return;
    }

    if (tagsSource && !tagsDestination) {
      const insertAfter = this.findProductInfoBlockAnchor(
        tagsSource,
        productInfoSource,
        productInfoDestination,
        sourceSectionId,
        currentSectionId
      );
      const markup = this.rewriteFetchedNodeMarkup(
        tagsSource.outerHTML,
        sourceSectionId,
        currentSectionId
      );

      if (insertAfter) {
        insertAfter.insertAdjacentHTML("afterend", markup);
      } else {
        productInfoDestination.prepend(markup);
      }
    }
  }

  findProductInfoBlockAnchor(
    sourceBlock,
    productInfoSource,
    productInfoDestination,
    sourceSectionId,
    currentSectionId
  ) {
    if (!productInfoSource || !productInfoDestination) return null;

    let node = sourceBlock.previousElementSibling;
    while (node) {
      const match = this.matchProductInfoBlock(
        node,
        productInfoDestination,
        sourceSectionId,
        currentSectionId
      );
      if (match) return match;
      node = node.previousElementSibling;
    }

    return productInfoDestination.querySelector(".product__title");
  }

  matchProductInfoBlock(
    sourceNode,
    productInfoDestination,
    sourceSectionId,
    currentSectionId
  ) {
    if (sourceNode.id) {
      const id = sourceNode.id.replace(sourceSectionId, currentSectionId);
      return document.getElementById(id);
    }

    if (sourceNode.classList?.contains("product__title")) {
      return productInfoDestination.querySelector(".product__title");
    }

    if (sourceNode.classList?.contains("product__description")) {
      return productInfoDestination.querySelector(".product__description");
    }

    if (sourceNode.id?.startsWith("price-")) {
      return productInfoDestination.querySelector(`[id^="price-"]`);
    }

    const variantPickerId = sourceNode.id?.startsWith("variant-picker-")
      ? sourceNode.id.replace(sourceSectionId, currentSectionId)
      : sourceNode
          .querySelector?.(`[id^="variant-picker-"]`)
          ?.id?.replace(sourceSectionId, currentSectionId);

    if (variantPickerId) {
      return document.getElementById(variantPickerId);
    }

    return null;
  }

  updateProductMediaFromHtml(mediaHtml, sourceSectionId, currentSectionId) {
    const sectionEl = this.getProductSectionElement(currentSectionId);
    if (!sectionEl) return;

    const mediaHtmlRoot = this.getMediaHtmlRoot(mediaHtml, sourceSectionId);

    const mediaSource = mediaHtmlRoot.querySelector(
      `[data-section="product-media-${sourceSectionId}"]`
    );
    const mediaDestination = this.getProductMediaContainer(currentSectionId);
    const mediaWrapperSource =
      mediaHtmlRoot.querySelector(".product__main .product__media-wrapper") ||
      mediaHtmlRoot.querySelector(".product__media-wrapper");
    const mediaWrapperDestination =
      sectionEl.querySelector(".product__main .product__media-wrapper") ||
      sectionEl.querySelector(".product__media-wrapper");

    if (!mediaWrapperSource && !mediaSource) return;
    if (!mediaWrapperDestination && !mediaDestination) return;

    this.destroyProductMediaSwipers(sectionEl);

    const sourceHasGallery = this.hasRealProductGalleryInHtml(
      mediaHtml,
      sourceSectionId
    );
    const destHasGallery = Boolean(
      mediaDestination?.querySelector(".js-media-list") ||
        mediaWrapperDestination?.querySelector(".js-media-list")
    );

    const rewriteMarkup = (markup) =>
      this.rewriteFetchedMarkupForSection(
        markup,
        sourceSectionId,
        currentSectionId
      );

    if (mediaWrapperSource && mediaWrapperDestination) {
      let wrapperMarkup = mediaWrapperSource.outerHTML;
      if (sourceSectionId !== currentSectionId) {
        wrapperMarkup = rewriteMarkup(wrapperMarkup);
      }
      mediaWrapperDestination.outerHTML = wrapperMarkup;
    } else if (mediaSource && mediaDestination) {
      let mediaMarkup = mediaSource.innerHTML;
      if (sourceSectionId !== currentSectionId) {
        mediaMarkup = rewriteMarkup(mediaMarkup);
      }
      mediaDestination.innerHTML = mediaMarkup;
    } else if (mediaWrapperSource && mediaDestination) {
      let wrapperMarkup = mediaWrapperSource.innerHTML;
      if (sourceSectionId !== currentSectionId) {
        wrapperMarkup = rewriteMarkup(wrapperMarkup);
      }
      mediaDestination.innerHTML = wrapperMarkup;
    } else if (!mediaWrapperSource && !mediaSource && mediaWrapperDestination) {
      mediaWrapperDestination.remove();
    }

    this.syncProductMediaLayoutClass(sectionEl, mediaHtmlRoot);
    this.updateProductModalFromHtml(
      mediaHtml,
      sourceSectionId,
      currentSectionId
    );

    this.reinitProductMediaGalleries(sectionEl);
    queueMicrotask(() => this.updateMediaForCurrentVariant());
  }

  getProductInfoFromHtml(html, sectionId) {
    if (!html || !sectionId) return null;

    return (
      html.getElementById(`ProductInfo-${sectionId}`) ||
      html
        .getElementById(`shopify-section-${sectionId}`)
        ?.querySelector(`#ProductInfo-${sectionId}`) ||
      html.querySelector(`[id^="ProductInfo-"]`)
    );
  }

  getPriceElementFromHtml(html, sectionId, productInfoSource) {
    return (
      html.getElementById(`price-${sectionId}`) ||
      productInfoSource?.querySelector(`#price-${sectionId}`) ||
      productInfoSource?.querySelector(`[id^="price-"]`) ||
      html.querySelector(`#price-${sectionId}`) ||
      html.querySelector(`[id^="price-"]`)
    );
  }

  updateElementsAfterFetch(html, mediaHtml = html, options = {}) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const forceMediaUpdate = options.forceMediaUpdate === true;
    const productInfoSource = this.getProductInfoFromHtml(
      html,
      sourceSectionId
    );
    const productInfoDestination = document.getElementById(
      `ProductInfo-${currentSectionId}`
    );

    // price
    const priceDestination = document.getElementById(
      `price-${currentSectionId}`
    );
    const priceSource = this.getPriceElementFromHtml(
      html,
      sourceSectionId,
      productInfoSource
    );

    if (priceDestination) {
      if (priceSource) {
        priceDestination.innerHTML = priceSource.innerHTML;
        priceDestination.className = priceSource.className;
        if (priceSource.hasAttributes()) {
          [...priceSource.attributes].forEach((attr) => {
            if (attr.name === "id") return;
            priceDestination.setAttribute(attr.name, attr.value);
          });
        }
        this.productInfoPriceUpdated = true;
      }

      if (
        this.productInfoPriceUpdated ||
        options.isCombinedFetch ||
        options.restorePriceVisibility
      ) {
        priceDestination.classList.remove("visibility-hidden");
      }
    }

    this.updateProductTitleAndBadgesFromHtml(
      productInfoSource,
      productInfoDestination,
      sourceSectionId,
      currentSectionId
    );

    // breadcrumbs
    const breadcrumbsSource = productInfoSource?.querySelector("#breadcrumbs");
    const breadcrumbsDestination =
      productInfoDestination?.querySelector("#breadcrumbs");
    if (breadcrumbsSource && breadcrumbsDestination) {
      breadcrumbsDestination.innerHTML = breadcrumbsSource.innerHTML;
    }

    this.updateProductDescriptionFromHtml(
      html,
      sourceSectionId,
      currentSectionId
    );

    this.updateProductTagsFromHtml(
      html,
      sourceSectionId,
      currentSectionId
    );

    this.updateGiftCardRecipientFromHtml(
      html,
      sourceSectionId,
      currentSectionId
    );

    this.updateFloatingProductBarFromHtml(
      html,
      sourceSectionId,
      currentSectionId
    );

    this.updateProductSkuFromHtml(html, sourceSectionId, currentSectionId);

    if (options.updateBuyButtons) {
      this.updateBuyButtonsFromHtml(
        productInfoSource,
        productInfoDestination,
        sourceSectionId,
        currentSectionId
      );
    }

    // inventory
    const inventorySource = html.getElementById(`Inventory-${sourceSectionId}`);
    const inventoryDestination = document.getElementById(
      `Inventory-${currentSectionId}`
    );
    if (inventorySource && inventoryDestination) {
      inventoryDestination.innerHTML = inventorySource.innerHTML;
      inventoryDestination.classList.toggle(
        "visibility-hidden",
        inventorySource.innerText === ""
      );
    }

    // color swatches label
    const colorNameSources = html.querySelectorAll(
      `[id^="ColorName-${sourceSectionId}"]`
    );
    const colorNameDestinations = document.querySelectorAll(
      `[id^="ColorName-${currentSectionId}"]`
    );
    if (colorNameSources?.length === colorNameDestinations?.length) {
      colorNameDestinations.forEach((colorNameDestination, index) => {
        colorNameDestination.classList.remove("visibility-hidden");
        colorNameDestination.innerHTML = colorNameSources[index].innerHTML;
      });
    }

    // variant image swatches
    if (this.isHighVariantNeedUpdate !== true) {
      const variantSwatchesSource = html.querySelector(
        `#variant-picker-${sourceSectionId} [data-is-variant-image-swatch="true"]`
      );
      const variantSwatchesDestination = document.querySelector(
        `#variant-picker-${currentSectionId} [data-is-variant-image-swatch="true"]`
      );
      if (variantSwatchesSource && variantSwatchesDestination) {
        let swatchesHtml = variantSwatchesSource.innerHTML;
        if (this.needsSectionIdRewrite()) {
          swatchesHtml = this.rewriteFetchedMarkupForSection(
            swatchesHtml,
            sourceSectionId,
            currentSectionId
          );
        }
        variantSwatchesDestination.innerHTML = swatchesHtml;
      }
    }

    // product media
    if (forceMediaUpdate) {
      this.updateProductMediaFromHtml(
        mediaHtml,
        sourceSectionId,
        currentSectionId
      );
    }

    if (options.isCombinedFetch || this.isCombinedListingsNeedUpdate) {
      this.updateLinkedProductsFromHtml(
        html,
        sourceSectionId,
        currentSectionId
      );
      this.reinitDropdownSelects();
    }
  }

  updateBuyButtonsFromHtml(
    productInfoSource,
    productInfoDestination,
    sourceSectionId,
    currentSectionId
  ) {
    if (!productInfoSource || !productInfoDestination) return;

    const sourceBuyButtons = productInfoSource.querySelector(
      ".product__buy-buttons"
    );
    const destBuyButtons = productInfoDestination.querySelector(
      ".product__buy-buttons"
    );
    if (!sourceBuyButtons || !destBuyButtons) return;

    const sourceButtonsRow = sourceBuyButtons.querySelector(
      ".product-form__buttons-row"
    );
    const destButtonsRow = destBuyButtons.querySelector(
      ".product-form__buttons-row"
    );
    if (sourceButtonsRow && destButtonsRow) {
      destButtonsRow.innerHTML = sourceButtonsRow.innerHTML;
    }

    const sourceCheckout = sourceBuyButtons.querySelector(
      ".product-form__checkout"
    );
    const destCheckout = destBuyButtons.querySelector(
      ".product-form__checkout"
    );
    if (sourceCheckout && destCheckout) {
      destCheckout.innerHTML = sourceCheckout.innerHTML;
    } else if (!sourceCheckout && destCheckout) {
      destCheckout.remove();
    } else if (sourceCheckout && !destCheckout) {
      const destButtons = destBuyButtons.querySelector(
        ".product-form__buttons"
      );
      destButtons?.appendChild(sourceCheckout.cloneNode(true));
    }

    if (
      window.Shopify?.PaymentButton &&
      destBuyButtons.querySelector(".shopify-payment-button")
    ) {
      Shopify.PaymentButton.init();
    }

    destBuyButtons.closest("product-form")?.refreshSubmitElements?.();

    this.getProductSectionElement(currentSectionId)
      ?.querySelectorAll("product-form")
      .forEach((productForm) => {
        if (typeof productForm.refreshSubmitElements === "function") {
          productForm.refreshSubmitElements();
        }
      });

    const sourceInstallment = productInfoSource.querySelector(
      ".installment-wrapper"
    );
    const destInstallment = productInfoDestination.querySelector(
      ".installment-wrapper"
    );
    if (sourceInstallment && destInstallment) {
      destInstallment.innerHTML = sourceInstallment.innerHTML;
    } else if (!sourceInstallment && destInstallment) {
      destInstallment.innerHTML = "";
      destInstallment.classList.add("visibility-hidden");
    } else if (sourceInstallment && !destInstallment) {
      const priceWrapper =
        productInfoDestination.querySelector(".price-wrapper");
      priceWrapper?.after(sourceInstallment.cloneNode(true));
    }
  }

  // methods for high variant products
  getSelectedValuesIds() {
    const controls = [...this.querySelectorAll(".product-form__controls")];

    controls.sort((a, b) => {
      return (
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
    });

    return controls
      .map((control) => this.getSelectedOptionValueId(control))
      .filter(Boolean);
  }

  createRequestUrl({
    currentVariantId = "",
    selectedValuesIds = [],
    combinedProductURL = "",
    preferOptionValues = false,
  }) {
    const productUrl =
      combinedProductURL ||
      this.pendingCombinedProductURL ||
      `${this.dataset.url}`;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    if (!productUrl) return "";

    const url = new URL(productUrl, window.location.origin);
    url.searchParams.delete("variant");
    url.searchParams.delete("option_values");
    url.searchParams.delete("section_id");

    if (preferOptionValues && selectedValuesIds.length) {
      url.searchParams.set("section_id", sectionId);
      url.searchParams.set(
        "option_values",
        selectedValuesIds.filter(Boolean).join(",")
      );
      return `${url.pathname}${url.search}`;
    }

    if (currentVariantId) {
      url.searchParams.set("variant", currentVariantId);
      url.searchParams.set("section_id", sectionId);
      return `${url.pathname}${url.search}`;
    }

    // -----
    // for high-variant products
    // and if variant not found in liquid <script data-all-variants-no-high>
    if (selectedValuesIds.length) {
      url.searchParams.set("section_id", sectionId);
      url.searchParams.set(
        "option_values",
        selectedValuesIds.filter(Boolean).join(",")
      );
      return `${url.pathname}${url.search}`;
    }

    url.searchParams.set("section_id", sectionId);
    return `${url.pathname}${url.search}`;
    // -----
  }

  setCurrentVariantAfterFetch(html) {
    // attr data-original-section use for Quick view modal
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    const variantPickerDestionation = document.getElementById(
      `variant-picker-${this.dataset.section}`
    );
    if (!variantPickerSource) return;

    const newVariantDataEl = variantPickerSource.querySelector(
      "[data-selected-variant]"
    );
    if (!newVariantDataEl) return;

    const newVariantData = newVariantDataEl.innerHTML.trim();
    this.variantData = null;

    let selectedVariant = null;
    if (newVariantData) {
      try {
        selectedVariant = JSON.parse(newVariantData);
      } catch {
        selectedVariant = null;
      }
    }

    const isLocallyResolvedVariant =
      !this.isHighVariantProduct() && !this.getSelectedExternalProductURL();

    if (isLocallyResolvedVariant) {
      this.updateOptions();
      const matched = this.findVariantBySelectedOptions();
      this.currentVariant = matched?.id ? matched : null;
    } else {
      this.currentVariant = selectedVariant?.id ? selectedVariant : null;
    }

    const oldEl = variantPickerDestionation?.querySelector(
      "[data-selected-variant]"
    );
    if (oldEl) {
      oldEl.textContent = this.currentVariant
        ? JSON.stringify(this.currentVariant)
        : newVariantData;
    }
  }

  updatePickerAvailabilityFromHtml(html) {
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;
    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    if (!variantPickerSource) return;

    const destControls = this.getSortedOptionControls();
    const sourceControls = [
      ...variantPickerSource.querySelectorAll(".product-form__controls"),
    ].sort(
      (a, b) =>
        Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
    );

    sourceControls.forEach((sourceControl, index) => {
      const destControl = destControls[index];
      if (!destControl) return;

      const sourceInputs = [
        ...sourceControl.querySelectorAll('input[type="radio"], option'),
      ];
      const destInputs = [
        ...destControl.querySelectorAll('input[type="radio"], option'),
      ];

      sourceInputs.forEach((sourceInput) => {
        const value = sourceInput.getAttribute("value");
        const destInput = destInputs.find(
          (input) => input.getAttribute("value") === value
        );
        if (!destInput) return;

        const isAvailable = !sourceInput.classList.contains("disabled");
        this.setOptionInputVisualState(destInput, isAvailable, value);
      });
    });

    this.variantData = null;
    if (this.querySelector("[data-all-variants-no-high]")) {
      this.getVariantData();
    }
    this.updateOptions();
    this.updateMasterId();
    this.reinitDropdownSelects();
  }

  reinitDropdownSelects() {
    this.querySelectorAll("variant-dropdown-select").forEach((dropdown) => {
      if (typeof dropdown.syncFromSelectedInput === "function") {
        dropdown.syncFromSelectedInput();
      }
    });
  }

  updatePickerInnerHtml(html) {
    // attr data-original-section use for Quick view modal
    const currentSectionId = this.dataset.section;
    const sourceSectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    const variantPickerSource = html.getElementById(
      `variant-picker-${sourceSectionId}`
    );
    const variantPickerDestination = document.getElementById(
      `variant-picker-${currentSectionId}`
    );

    if (variantPickerSource && variantPickerDestination) {
      let pickerHtml = variantPickerSource.innerHTML;
      if (this.needsSectionIdRewrite()) {
        pickerHtml = this.rewriteFetchedMarkupForSection(
          pickerHtml,
          sourceSectionId,
          currentSectionId
        );
      }
      variantPickerDestination.innerHTML = pickerHtml;

      this.variantData = null;
      if (
        variantPickerDestination.querySelector("[data-all-variants-no-high]")
      ) {
        this.getVariantData();
      }

      this.updateOptions();
      this.reinitDropdownSelects();
      this.updateMasterId();
      if (
        variantPickerDestination.querySelector("[data-all-variants-no-high]") &&
        !this.isHighVariantProduct()
      ) {
        this.updateVariantStatuses();
      }
      this.syncAddToCartState();
    }
  }
}

if (!customElements.get("variant-selects")) {
  customElements.define("variant-selects", VariantSelects);
}

window.initFeaturedProduct = function (sectionEl) {
  if (!sectionEl) return;
  if (typeof subSliderInit === "function") subSliderInit(sectionEl);
  if (typeof sliderInit === "function") sliderInit(sectionEl);
};

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    this.options = this.getSortedOptionControls().map((fieldset) =>
      this.getSelectedOptionValue(fieldset)
    );
  }
}

if (!customElements.get("variant-radios")) {
  customElements.define("variant-radios", VariantRadios);
}

class VariantDropdownSelect extends HTMLElement {
  constructor() {
    super();
    this.isActive = false;
    this._preventDoubleClick = this.preventDoubleClick.bind(this);
    this._onCurrentClick = this.onCurrentClick.bind(this);
    this._onKeyUp = this.onKeyUp.bind(this);
    this._onOptionsClick = this.onClickOption.bind(this);
    this._onKeyUpOptions = this.onKeyUpOptions.bind(this);
    this._onOutsideClick = this.onOutsideClick.bind(this);
    this._onOptionsScroll = this.updateScrollShadows.bind(this);
  }

  initElements() {
    this.currentEl = this.querySelector(".dropdown-select__current");
    this.optionsWrapperEl = this.querySelector(".dropdown-select__options");
    this.hiddenInput = this.querySelector("input[type='hidden']");
    if (!this.currentEl || !this.optionsWrapperEl || !this.hiddenInput) {
      return false;
    }

    this.optionsListEl = this.optionsWrapperEl.querySelector("ul");
    this.shadowTop = this.optionsWrapperEl.querySelector(
      ".select-wrapper__scroll-shadow.shadow-top"
    );
    this.shadowBottom = this.optionsWrapperEl.querySelector(
      ".select-wrapper__scroll-shadow.shadow-bottom"
    );

    this.optionsEls = Array.from(this.optionsWrapperEl.querySelectorAll("li"));
    this.inputs = Array.from(
      this.optionsWrapperEl.querySelectorAll('input[type="radio"]')
    );
    this.hasColorSwatch = this.currentEl.classList.contains(
      "dropdown-select__current--with-color"
    );
    this.optionPosition = this.getOptionPosition();
    return true;
  }

  connectedCallback() {
    if (!this.initElements()) return;

    this.syncFromSelectedInput();
    this.onClose();

    this.currentEl.addEventListener("click", this._onCurrentClick);
    this.currentEl.addEventListener("keyup", this._onKeyUp);
    this.currentEl.addEventListener("dblclick", this._preventDoubleClick);
    this.optionsWrapperEl.addEventListener("click", this._onOptionsClick);
    this.optionsWrapperEl.addEventListener("keyup", this._onKeyUpOptions);
    this.optionsListEl?.addEventListener("scroll", this._onOptionsScroll);
    document.addEventListener("click", this._onOutsideClick);
  }

  disconnectedCallback() {
    if (!this.currentEl || !this.optionsWrapperEl) return;

    this.currentEl.removeEventListener("click", this._onCurrentClick);
    this.currentEl.removeEventListener("keyup", this._onKeyUp);
    this.currentEl.removeEventListener("dblclick", this._preventDoubleClick);
    this.optionsWrapperEl.removeEventListener("click", this._onOptionsClick);
    this.optionsWrapperEl.removeEventListener("keyup", this._onKeyUpOptions);
    this.optionsListEl?.removeEventListener("scroll", this._onOptionsScroll);
    document.removeEventListener("click", this._onOutsideClick);
  }

  updateScrollShadows() {
    if (!this.optionsListEl) return;

    const { scrollTop, clientHeight, scrollHeight } = this.optionsListEl;
    const hasOverflow = scrollHeight > clientHeight + 1;

    this.shadowTop?.classList.toggle("show", hasOverflow && scrollTop > 0);
    this.shadowBottom?.classList.toggle(
      "show",
      hasOverflow && scrollTop + clientHeight < scrollHeight - 5
    );
  }

  resetScrollShadows() {
    this.shadowTop?.classList.remove("show");
    this.shadowBottom?.classList.remove("show");
  }

  syncFromSelectedInput() {
    if (!this.initElements()) return;

    const currentValueEl = this.currentEl.querySelector(
      "[data-dropdown-current-value]"
    );
    if (!currentValueEl) return;

    const checkedInput =
      this.optionsWrapperEl.querySelector('input[type="radio"]:checked') ||
      this.inputs.find((input) => input.hasAttribute("checked"));

    const newValue = checkedInput?.value || this.hiddenInput.value;
    if (!newValue) return;

    currentValueEl.textContent = newValue;
    this.hiddenInput.value = newValue;

    if (checkedInput?.dataset?.optionValueId) {
      this.hiddenInput.dataset.optionValueId =
        checkedInput.dataset.optionValueId;
    } else {
      delete this.hiddenInput.dataset.optionValueId;
    }

    if (checkedInput?.dataset?.productUrl) {
      this.hiddenInput.dataset.productUrl = checkedInput.dataset.productUrl;
    } else {
      delete this.hiddenInput.dataset.productUrl;
    }

    this.inputs.forEach((input) => {
      const isSelected = input.value === newValue;
      input.checked = isSelected;
      if (isSelected) {
        input.setAttribute("checked", "");
      } else {
        input.removeAttribute("checked");
      }
    });

    if (this.hasColorSwatch) {
      const selectedLi =
        checkedInput?.closest("li") ||
        this.optionsEls.find((optionEl) => optionEl.dataset.value === newValue);
      const newColor = selectedLi?.dataset?.color;
      if (newColor) {
        this.hiddenInput.dataset.colorSwatch = newColor;
        this.currentEl.style.setProperty("--swatch-color", newColor);
      }
    }
  }

  onCurrentClick(event) {
    event.stopPropagation();
    if (this.isActive) {
      this.onClose();
    } else {
      this.onOpen();
    }
  }

  onKeyUp(event) {
    if (event.code?.toUpperCase() === "ENTER") {
      event.preventDefault();
      event.stopPropagation();
      if (this.isActive) {
        this.onClose();
      } else {
        this.onOpen();
      }
    }
  }

  preventDoubleClick(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  onClickOption(event) {
    const optionEl = event.target.closest("li");
    const currentValueEl = this.currentEl.querySelector(
      "[data-dropdown-current-value]"
    );

    if (
      !optionEl ||
      !currentValueEl ||
      !this.optionsWrapperEl.contains(optionEl)
    ) {
      event.preventDefault();
      return;
    }

    const optionInput = optionEl.querySelector('input[type="radio"]');
    if (!optionInput) {
      event.preventDefault();
      return;
    }

    const newValue = optionEl.dataset.value;

    currentValueEl.textContent = newValue;
    this.hiddenInput.value = newValue;

    if (optionInput?.dataset?.optionValueId) {
      this.hiddenInput.dataset.optionValueId =
        optionInput.dataset.optionValueId;
    } else {
      delete this.hiddenInput.dataset.optionValueId;
    }

    if (this.hasColorSwatch) {
      const newColor = optionEl.dataset.color;
      this.hiddenInput.dataset.colorSwatch = newColor;
      this.currentEl.style.setProperty("--swatch-color", newColor);
    }

    this.inputs.forEach((el) => {
      el.checked = false;
      el.removeAttribute("checked");
    });
    if (optionInput) {
      optionInput.checked = true;
      optionInput.setAttribute("checked", "");
    }

    const changeEvent = new Event("change", { bubbles: true });
    if (optionInput?.dataset?.productUrl) {
      this.hiddenInput.dataset.productUrl = optionInput.dataset.productUrl;
      changeEvent.productUrl = optionInput.dataset.productUrl;
    } else {
      delete this.hiddenInput.dataset.productUrl;
    }
    this.hiddenInput.dispatchEvent(changeEvent);

    this.onClose();
    this.currentEl.focus();
  }

  onKeyUpOptions(event) {
    if (event.code === "Escape" && this.isActive) {
      event.preventDefault();
      this.onClose();
      this.currentEl.focus();
    }
  }

  onOpen() {
    document.querySelectorAll("variant-dropdown-select").forEach((dropdown) => {
      if (dropdown !== this && typeof dropdown.onClose === "function") {
        dropdown.onClose();
      }
    });

    this.optionsWrapperEl.classList.add("active");
    this.currentEl.setAttribute("aria-expanded", "true");
    this.isActive = true;

    if (this.optionsListEl) {
      this.optionsListEl.scrollTop = 0;
    }
    requestAnimationFrame(() => this.updateScrollShadows());

    const currentIndex = this.inputs.findIndex((inp) =>
      inp.hasAttribute("checked")
    );
    this.inputs[currentIndex >= 0 ? currentIndex : 0]?.focus();
  }

  onClose() {
    this.optionsWrapperEl.classList.remove("active");
    this.currentEl.setAttribute("aria-expanded", "false");
    this.isActive = false;
    this.resetScrollShadows();
  }

  onOutsideClick(event) {
    if (!this.isActive || this.contains(event.target)) return;
    this.onClose();
  }

  getOptionPosition() {
    const parentFieldset = this.closest(".product-form__controls");
    return Number(parentFieldset?.dataset?.optionPosition || -1);
  }

  updateCurrentOption(selectedValues = []) {
    // Method is used to synchronize after changes options in sticky bar.
    if (!this.initElements() || this.optionPosition === -1) return;
    if (!selectedValues?.length) return;

    const newValue = selectedValues[this.optionPosition - 1];
    if (!newValue) return;

    const currentValueEl = this.currentEl.querySelector(
      "[data-dropdown-current-value]"
    );
    if (!currentValueEl) return;

    currentValueEl.textContent = newValue;
    this.hiddenInput.value = newValue;

    this.inputs.forEach((input) => {
      const isSelected = input.value === newValue;
      input.checked = isSelected;
      if (isSelected) {
        input.setAttribute("checked", "");
      } else {
        input.removeAttribute("checked");
      }
    });

    if (this.hasColorSwatch) {
      const selectedLi = this.optionsEls.find(
        (optionEl) => optionEl.dataset.value === newValue
      );
      const newColor = selectedLi?.dataset?.color;
      if (newColor) {
        this.hiddenInput.dataset.colorSwatch = newColor;
        this.currentEl.style.setProperty("--swatch-color", newColor);
      }
    }
  }
}

if (!customElements.get("variant-dropdown-select")) {
  customElements.define("variant-dropdown-select", VariantDropdownSelect);
}

class PasswordViewer {
  constructor() {
    const passwordField = document.querySelectorAll(".field--pass");

    passwordField.forEach((el) => {
      const input = el.querySelector("input");
      const btnWrapper = el.querySelector(".button-pass-visibility");
      const btnOpen = el.querySelector(".icon-eye-close");
      const btnClose = el.querySelector(".icon-eye");

      input.addEventListener("input", () => {
        input.value !== ""
          ? (btnWrapper.style.display = "block")
          : (btnWrapper.style.display = "none");
      });

      btnOpen.addEventListener("click", () => {
        input.type = "text";
        btnOpen.style.display = "none";
        btnClose.style.display = "block";
      });

      btnClose.addEventListener("click", () => {
        input.type = "password";
        btnOpen.style.display = "block";
        btnClose.style.display = "none";
      });
    });
  }
}

// -----------------------------------------------------------------------------
// COLOR SWATCHES START
function generateSrcset(image, widths = []) {
  const imageUrl = new URL(image["src"]);
  return widths
    .filter((width) => width <= image["width"])
    .map((width) => {
      imageUrl.searchParams.set("width", width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(", ");
}

function createImageElement(image, classes, sizes, productTitle) {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(
    previewImage,
    [165, 360, 533, 720, 940, 1066]
  );
  newImage.loading = "lazy";
  return newImage;
}

function checkSwatches() {
  document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
    wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
      input.addEventListener("click", (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;

        if (event.currentTarget.checked && primaryImage) {
          wrapper
            .querySelector(".js-color-swatches-link")
            .setAttribute("href", event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper
              .querySelector('.card__add-to-cart button[name="add"]')
              .setAttribute("aria-disabled", false);
            if (
              wrapper.querySelector(
                '.card__add-to-cart button[name="add"] > span'
              )
            ) {
              wrapper
                .querySelector('.card__add-to-cart button[name="add"] > span')
                .classList.remove("hidden");
              wrapper
                .querySelector(
                  '.card__add-to-cart button[name="add"] .sold-out-message'
                )
                .classList.add("hidden");
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value =
              event.currentTarget.dataset.variantId;
          }
          const currentColor = event.currentTarget.value;
          const currentVariantId = event.currentTarget.dataset?.variantId;

          fetch(`${window.Shopify.routes.root}products/${handleProduct}.js`)
            .then((response) => response.json())
            .then((product) => {
              const variant = product.variants.find(
                (item) =>
                  (currentVariantId &&
                    item.id == currentVariantId &&
                    item.featured_media != null &&
                    item.options.includes(currentColor)) ||
                  (!currentVariantId &&
                    item.featured_media != null &&
                    item.options.includes(currentColor))
              );

              if (variant) {
                const newPrimaryImage = createImageElement(
                  variant["featured_media"],
                  primaryImage.className,
                  primaryImage.sizes,
                  product.title
                );

                if (newPrimaryImage.src !== primaryImage.src) {
                  let flag = false;
                  if (secondaryImage) {
                    const secondaryImagePathname = new URL(secondaryImage.src)
                      .pathname;
                    const newPrimaryImagePathname = new URL(newPrimaryImage.src)
                      .pathname;

                    if (secondaryImagePathname === newPrimaryImagePathname) {
                      primaryImage.remove();
                      secondaryImage.classList.remove("media--second");
                      secondaryImage.classList.add("media--first");
                      flag = true;
                    }
                  }
                  if (!flag) {
                    primaryImage.style.transition = "opacity 200ms ease-in-out";
                    primaryImage.style.opacity = "0";
                    setTimeout(() => {
                      primaryImage.replaceWith(newPrimaryImage);
                      newPrimaryImage.style.opacity = "0";
                      newPrimaryImage.style.transition =
                        "opacity 200ms ease-in-out";
                      newPrimaryImage.offsetHeight;
                      newPrimaryImage.style.opacity = "1";
                      if (secondaryImage) {
                        secondaryImage.remove();
                      }
                    }, 200);
                  }
                }
              }
            })
            .catch(() => {});
        }
      });
    });
  });
}

// func reused in other places
function colorSwatches() {
  checkSwatches();

  document.addEventListener("shopify:section:load", function () {
    checkSwatches();
  });
}

(function () {
  colorSwatches();
})();

// COLOR SWATCHES END
// -----------------------------------------------------------------------------

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      if (this.querySelector(".product-recommendations__loading")) {
        this.querySelector(".product-recommendations__loading").classList.add(
          "loading"
        );
        this.querySelector(".product-recommendations__loading").style.display =
          "flex";
      }

      this.recommendationsSlider = null;

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          checkSwatches();

          const addClasses = (slider) => {
            const sliderWrapper = slider.querySelector(
              ".product-recommendations__list"
            );
            const slides = slider.querySelectorAll(
              ".product-recommendations__item"
            );

            slider.classList.add("swiper");
            if (sliderWrapper) sliderWrapper.classList.add("swiper-wrapper");

            slides.forEach((slide) => {
              slide.classList.add("swiper-slide");
            });
          };

          const removeClasses = (slider) => {
            const sliderWrapper = slider.querySelector(
              ".product-recommendations__list"
            );
            const slides = slider.querySelectorAll(
              ".product-recommendations__item"
            );

            slider.classList.remove("swiper");
            if (sliderWrapper) sliderWrapper.classList.remove("swiper-wrapper");

            slides.forEach((slide) => {
              slide.removeAttribute("style");
              slide.classList.remove("swiper-slide");
            });
          };

          const initSlider = (settings) => {
            const slider = this.querySelector(".js-recommendation-swiper");

            if (!slider) return;
            const mobSlidesPreView = slider.classList.contains(
              "js-recommendation-swiper--visible-overflow"
            )
              ? "auto"
              : 1;

            const sliderSettings = {
              slidesPerView: mobSlidesPreView,
              spaceBetween: 16,
              speed: 800,
              mousewheel: {
                forceToAxis: true,
              },
              allowTouchMove: true,
              navigation: {
                nextEl: slider.querySelector(".swiper-button-next"),
                prevEl: slider.querySelector(".swiper-button-prev"),
                disabledClass: "swiper-button-disabled",
              },
            };

            const scrollbarSettings = {
              slidesPerView: 1,
              spaceBetween: 16,
              mousewheel: {
                forceToAxis: true,
              },
              speed: 400,
              allowTouchMove: true,
              breakpoints: {
                576: {
                  slidesPerView: 2,
                },
                990: {
                  slidesPerView: 3,
                },
                1440: {
                  slidesPerView: 4,
                },
              },
              scrollbar: {
                el: slider.querySelector(".swiper-scrollbar"),
                grabCursor: true,
                draggable: true,
                hide: false,
              },
            };
            if (slider) {
              addClasses(slider);

              this.recommendationsSlider = new Swiper(
                slider,
                settings === "scrollbar" ? scrollbarSettings : sliderSettings
              );
            }
          };

          const destroySlider = () => {
            const slider = this.querySelector(".js-recommendation-swiper");

            if (slider) {
              removeClasses(slider);
              this.recommendationsSlider.destroy(true, true);
              this.recommendationsSlider = null;
            }
          };

          const initSection = () => {
            const resizeObserver = new ResizeObserver((entries) => {
              const [entry] = entries;
              if (entry.contentRect.width < 576) {
                if (this.recommendationsSlider) destroySlider();
                initSlider("slider");
              } else {
                if (this.recommendationsSlider) destroySlider();
                initSlider("scrollbar");
              }
            });

            const sectionOuter = this.closest(
              ".product-recommendations__outer"
            );
            const slider = this.querySelector(".js-recommendation-swiper");

            if (sectionOuter && slider) {
              resizeObserver.observe(sectionOuter);
            }
          };

          initSection();

          // Initialize buttons animations (global function initButtonsAnimation in global.js)
          initButtonsAnimation(this);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.querySelector(".product-recommendations__loading")) {
            this.querySelector(
              ".product-recommendations__loading"
            ).classList.remove("loading");
            this.querySelector(".product-recommendations__loading").remove();
          }
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  cents = parseInt(cents, 10);

  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || theme.moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ",",
    decimal = "."
  ) {
    if (isNaN(number) || number == null) {
      return "0";
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = precision > 0 ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  const match = formatString.match(placeholderRegex);
  const formatType = match ? match[1] : "amount";

  switch (formatType) {
    case "amount":
      value = formatWithDelimiters(cents, 2, ",", ".");
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ", ".");
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    default:
      value = formatWithDelimiters(cents, 2, ",", ".");
  }

  return formatString.replace(placeholderRegex, value);
}
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.elements.button.addEventListener("click", this.togglePanel.bind(this));
    this.addEventListener("keydown", this.onEscapePress.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  connectedCallback() {
    document.addEventListener("click", this.handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  showPanel() {
    this.elements.button.setAttribute("aria-expanded", "true");
    this.elements.panel.removeAttribute("hidden");
  }

  togglePanel() {
    if (this.elements.button.getAttribute("aria-expanded") === "true") {
      this.hidePanel();
    } else {
      this.showPanel();
    }
  }

  onEscapePress(event) {
    if (event.key === "Escape") {
      this.hidePanel();
    }
  }

  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    this.querySelector("form")?.submit();
    this.hidePanel();
  }
}

if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}

// BUTTON ANIMATION CODE START
// -----------------------------------------------------------------------------

function initButtonsAnimation(parent) {
  if (!parent) return;
  const initButton = (button) => {
    const circle = button.querySelector(".animated-button-circle");

    const fillEffect = (e) => {
      const rect = button.getBoundingClientRect(),
        i = e.clientY - rect.top,
        s = e.clientX - rect.left,
        r = i / rect.height,
        n = s / rect.width;

      circle.style.transformOrigin = 100 * n + "% " + 100 * r + "%";
    };

    if (circle) {
      button.addEventListener("mouseenter", fillEffect);
      button.addEventListener("mouseleave", fillEffect);
    }
  };

  const buttons = parent.querySelectorAll(
    ".button--primary, .button--secondary, .button--transparent, .customer .button--primary, .customer .button--secondary, .customer .button--transparent, .products-tabs__tab"
  );

  if (buttons.length) {
    buttons.forEach((button) => {
      initButton(button);
    });
  }
}

initButtonsAnimation(document);

// BUTTON ANIMATION CODE END
// -----------------------------------------------------------------------------

// SLIDE UP, SLIDE DOWN
// -----------------------------------------------------------------------------
function slideUp(toggleEl, contentEl, duration = 300) {
  // Get the current height of the element
  const height = contentEl.clientHeight;

  // Set animation styles
  contentEl.style.transitionProperty = "height, margin, padding";
  contentEl.style.transitionDuration = duration + "ms";
  contentEl.style.overflow = "hidden";

  // Set initial values
  contentEl.style.height = height + "px";
  contentEl.style.padding = "0";
  contentEl.style.margin = "0";

  // Delay to start animation
  setTimeout(function () {
    // Set the values ​​for hiding the element
    contentEl.style.height = "0";
    contentEl.style.padding = "0";
    contentEl.style.margin = "0";
  }, 10);

  // Delay for animation to complete
  setTimeout(function () {
    // Remove installed styles after animation
    toggleEl.classList.remove("active");
    contentEl.classList.remove("active");
    contentEl.style.removeProperty("height");
    contentEl.style.removeProperty("padding");
    contentEl.style.removeProperty("margin");
    contentEl.style.removeProperty("overflow");
    contentEl.style.removeProperty("transition-duration");
    contentEl.style.removeProperty("transition-property");
  }, duration);
}

function slideDown(toggleEl, contentEl, duration = 300) {
  toggleEl.classList.add("active");
  contentEl.classList.add("active");
  contentEl.style.overflow = "hidden";
  contentEl.style.height = "0";

  const height = contentEl.scrollHeight;

  setTimeout(function () {
    contentEl.style.height = height + "px";
  }, 10);

  setTimeout(function () {
    contentEl.style.removeProperty("overflow");
    contentEl.style.removeProperty("height");
  }, duration);
}

// SLIDE UP, SLIDE DOWN END
// -----------------------------------------------------------------------------

// CUSTOM ELEMENTS ON PRODUCT PAGE START
// -----------------------------------------------------------------------------


class ProductAdditionalService extends HTMLElement {
  static selectedServices = [];

  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.variantId = this.dataset.serviceProductVariantId;
    this.mainProductTitle = this.dataset.mainProductTitle;

    this.productInfo = this.closest(`#ProductInfo-${this.sectionId}`);
    this.dynamicBtns = this.productInfo?.querySelector(
      ".product-form__checkout"
    );

    this.checkbox = this.querySelector("input[type='checkbox']");
    this.checkbox?.addEventListener("change", this.onSelect.bind(this));
  }

  onSelect(event) {
    event.preventDefault();
    const propertyName =
      window.cartStrings?.additional_service_property || "Added with";

    if (this.checkbox.checked) {
      if (
        !ProductAdditionalService.selectedServices.some(
          (item) => item.id === this.variantId
        )
      ) {
        ProductAdditionalService.selectedServices.push({
          id: this.variantId,
          quantity: 1,
          properties: {
            [`${propertyName}`]: this.mainProductTitle,
          },
        });
      }
    } else {
      ProductAdditionalService.selectedServices =
        ProductAdditionalService.selectedServices.filter(
          (item) => item.id !== this.variantId
        );
    }

    if (this.dynamicBtns) {
      this.dynamicBtns.classList.toggle(
        "disabled",
        ProductAdditionalService.selectedServices.length > 0
      );
    }
  }

  getItems(formData) {
    if (!formData || ProductAdditionalService.selectedServices.length === 0) {
      return;
    }

    const mainItemId = formData.get("id");
    const mainItemQuantity = formData.get("quantity");
    if (!mainItemId || !mainItemQuantity) return;

    const additionalItems = ProductAdditionalService.selectedServices.map(
      (service) => {
        return {
          id: service.id,
          quantity: service.quantity,
          properties: service.properties,
        };
      }
    );

    const mainProperties = {};
    for (const [key, value] of formData.entries()) {
      if (key.startsWith("properties[")) {
        const cleanKey = key.replace(/^properties\[(.*?)\]$/, "$1");
        mainProperties[cleanKey] = value;
      }
    }

    return [
      ...additionalItems,
      {
        id: mainItemId,
        quantity: mainItemQuantity,
        properties: mainProperties,
      },
    ];
  }

  clearItems() {
    ProductAdditionalService.selectedServices = [];
  }
}

if (!customElements.get("product-additional-service")) {
  customElements.define("product-additional-service", ProductAdditionalService);
}

// CUSTOM ELEMENTS ON PRODUCT PAGE END
// -----------------------------------------------------------------------------

// CART REFRESH EVENT
// -----------------------------------------------------------------------------

document.documentElement.addEventListener("cart:refresh", () => {
  const sectionsToUpdate = [
    { id: "cart-count-bubble", selector: "#cart-icon-bubble" },
    { id: "cart-drawer", selector: "#CartDrawer" },
    { id: "main-cart-items", selector: ".cart-items-wrapper" },
    { id: "main-cart-footer", selector: ".cart__footer" },
    { id: "main-cart-shipping", selector: ".cart-shipping" },
  ];

  sectionsToUpdate.forEach((section) => {
    fetch(`${routes.cart_url}?section_id=${section.id}`)
      .then((response) => response.text())
      .then((html) => {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html");
        const sourceSection = parsedHTML.querySelector(section.selector);
        const destinationSection = document.querySelector(section.selector);
        if (sourceSection && destinationSection) {
          destinationSection.innerHTML = sourceSection.innerHTML;
        }
      })
      .catch((e) => console.error(`Error updating ${section.id}:`, e));
  });
});

// CART REFRESH EVENT END
// -----------------------------------------------------------------------------
